<template>
  <div id="productModule" class="productModuleContainer" style="position: relative">
    <div class="fake-scrollbar mobile">
      <div class="fake-thumb"></div>
    </div>
    <div class="product-box">
      <div class="product-table scroll-fade-up" :class="{ newTypeTable: newTypeTable, etfLayoutTable: tabIndex == 4 }">
        <div class="product-table-th etf-layout" v-if="tabIndex == 4">
          <div class="product-table-td body-16_regular md-footnote-medium_12">交易产品</div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">卖出价</div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">买入价</div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">投资焦点</div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">ETF 规模（亿美元）</div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            {{ returnTextMap[currentReturnKey] }}

            <div class="dropdown-container cursor-pointer" @mouseenter="!isMoible && (showReturnDropdown = true)"
              @mouseleave="!isMoible && (showReturnDropdown = false)"
              @click.stop="showReturnDropdown = !showReturnDropdown">
              <span class="iconfont icon-a-down"></span>
              <div class="etf-dropdown-menu" v-show="showReturnDropdown">
                <div class="etf-dropdown-menu-inner box-border">
                  <div class="etf-dropdown-item" :class="{ active: currentReturnKey === 'total_return' }"
                    @click.stop="selectReturn('total_return')">历史总收益率</div>
                  <div class="etf-dropdown-item" :class="{ active: currentReturnKey === '10y' }"
                    @click.stop="selectReturn('10y')">过去 10 年</div>
                  <div class="etf-dropdown-item" :class="{ active: currentReturnKey === '5y' }"
                    @click.stop="selectReturn('5y')">过去 5 年</div>
                  <div class="etf-dropdown-item" :class="{ active: currentReturnKey === '3y' }"
                    @click.stop="selectReturn('3y')">过去 3 年</div>
                  <div class="etf-dropdown-item" :class="{ active: currentReturnKey === '1y' }"
                    @click.stop="selectReturn('1y')">过去 1 年</div>
                </div>
              </div>
            </div>
          </div>

          <div class="product-table-td body-16_regular md-footnote-medium_12">
            {{ betaTextMap[currentBetaKey] }}

            <span class="iconfont icon-a-tipsicon info-icon cursor-pointer" @mouseenter="showBetaTooltip = true"
              @mouseleave="showBetaTooltip = false">
              <div class="tooltip-box box-border" v-show="showBetaTooltip">
                β 值衡量 ETF 相对市场的波动敏感度，基于历史数据计算，不代表未来表现。
              </div>
            </span>

            <div class="dropdown-container cursor-pointer" @mouseenter="!isMoible && (showBetaDropdown = true)"
              @mouseleave="!isMoible && (showBetaDropdown = false)" @click.stop="showBetaDropdown = !showBetaDropdown">
              <span class="iconfont icon-a-down"></span>
              <div class="etf-dropdown-menu" v-show="showBetaDropdown">
                <div class="etf-dropdown-menu-inner box-border">
                  <div class="etf-dropdown-item" :class="{ active: currentBetaKey === 'beta_5y' }"
                    @click.stop="selectBeta('beta_5y')">过去 5 年 β</div>
                  <div class="etf-dropdown-item" :class="{ active: currentBetaKey === 'beta_3y' }"
                    @click.stop="selectBeta('beta_3y')">过去 3 年 β</div>
                  <div class="etf-dropdown-item" :class="{ active: currentBetaKey === 'beta_1y' }"
                    @click.stop="selectBeta('beta_1y')">过去 1 年 β</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-table-th" v-else>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            交易产品
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            卖出价
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            买入价
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            点差
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            杠杆
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            流动性深度
          </div>
        </div>
        <div class="product-table-row" v-for="(item, index) in isMoible
          ? showData.slice(
            (targetNavigationIndex - 1) * 6,
            (targetNavigationIndex - 1) * 6 + 6
          )
          : showData" :key="index" :class="{ newTypeTableChooseRow: newTypeTable && index == innerTickIndex }">
          <div class="product-table-tr etf-layout" v-if="tabIndex == 4" v-show="(index > 7 && showMore) || index <= 7">
            <div class="product-table-td">
              <div class="subtitle-18_medium md-body-14_medium">{{ item.symbolZh || item.symbol }}</div>
              <div class="etf-symbol-text body-14_regular">{{ item.symbol }}</div>
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium" :class="[item.tick[0]?.bidClassName]">
              {{ item.tick[0]?.bid_price }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium" :class="[item.tick[0]?.askClassName]">
              {{ item.tick[0]?.ask_price }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium">{{ item.focus }}</div>
            <div class="product-table-td body-16_medium md-body-14_medium">{{ item.fundSize }}</div>
            <div class="product-table-td body-16_medium md-body-14_medium"
              :class="{ 'product-green': item.returns[currentReturnKey]?.includes('+'), 'product-red': item.returns[currentReturnKey]?.includes('-') }">
              {{ item.returns[currentReturnKey] }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium">
              <span v-if="item.symbol === 'SMH'" class="demo-outline">{{ item.betas[currentBetaKey] }}</span>
              <span v-else>{{ item.betas[currentBetaKey] }}</span>
            </div>
          </div>
          <div class="product-table-tr" v-else v-show="(index > 7 && showMore) || index <= 7 || tabIndex < 3"
            @click="showFormPopup(index)">
            <div class="product-table-td subtitle-18_medium md-body-14_medium">
              <template v-if="newTypeTable">
                {{ item.symbolZh || item.symbol }}
              </template>
              <template v-else>
                <div class="flex items-center productPageTable">
                  <img :src='getImage(item.symbol)' alt="">
                  <div>
                    <div>{{ item.symbolZh }}</div>
                    <div class="body-14_regular secondTitle">{{ item.symbol }}</div>
                  </div>
                </div>
              </template>
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium"
              :style="{ opacity: newTypeTable && !isMoible && index == innerTickIndex ? 0 : 1 }"
              :class="[item.tick[0].bidClassName]">
              {{ item.tick[0].bid_price }}
            </div>

            <div class="product-table-td body-16_medium md-body-14_medium"
              :style="{ opacity: newTypeTable && !isMoible && index == innerTickIndex ? 0 : 1 }"
              :class="[item.tick[0].askClassName]">
              {{ item.tick[0].ask_price }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium"
              :style="{ opacity: newTypeTable && !isMoible && index == innerTickIndex ? 0 : 1 }">
              {{ item.tick[0].spread }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium" v-html="item.rule"
              :style="{ opacity: newTypeTable && !isMoible && index == innerTickIndex ? 0 : 1 }">
            </div>

            <div class="
                product-table-td
                body-16_medium
                md-footnote-medium_12
                cursor-pointer
              ">
              查看
              <span class="iconfont icon-a-down rotate90"></span>
            </div>
          </div>
          <div class="product-table-row newTypeInnerTable" v-if="newTypeTable && !isMoible && innerTickIndex == index">
            <div class="product-innertable body-16_medium">
              <div class="product-innertable-th md-footnote-medium_12">
                <div class="product-innertable-td">
                  layer
                  <span class="iconfont icon-a-tipsicon cursor-pointer" data-popover="p1"></span>

                </div>
                <div class="product-innertable-td">Bid</div>
                <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                  Bid Volume
                </div>
                <div class="product-innertable-td">Ask</div>
                <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                  Ask Volume
                </div>
                <div class="product-innertable-td">Spread</div>
              </div>
              <div class="product-innertable-tbody">
                <div class="product-innertable-tr md-body-14_medium" v-for="(el, i) in innerTickList">
                  <div class="product-innertable-td">{{ i + 1 }}</div>
                  <div class="product-innertable-td" :class="[el.bidClassName]">
                    {{ el.bid_price }}
                  </div>
                  <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                    {{ el.bid_size ? el.bid_size : "-" }}
                  </div>
                  <div class="product-innertable-td" :class="[el.askClassName]">
                    {{ el.ask_price }}
                  </div>
                  <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                    {{ el.ask_size ? el.ask_size : "-" }}
                  </div>
                  <div class="product-innertable-td">{{ el.spread }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="iBtn secondary-default_large" v-if="tabIndex == 3 || tabIndex == 4" @click="showMore = !showMore">
        查看所有产品
        <span class="iconfont icon-a-down" :class="{ rotate180: showMore }"></span>
      </div>
      <div class="formPopup box-border" :class="{ showFormPopup: popupControl }"
        v-if="(newTypeTable && isMoible) || !newTypeTable">
        <span class="formPopupClose" @click="closePopup">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g clip-path="url(#clip0_4123_9841)">
              <path
                d="M23.2893 7.29284C23.6798 6.90235 24.3128 6.90242 24.7034 7.29284C25.0939 7.68336 25.0939 8.31637 24.7034 8.7069L17.4104 15.9999L24.7034 23.2928L24.7724 23.369C25.0925 23.7617 25.0694 24.3408 24.7034 24.7069C24.3374 25.0727 23.7582 25.0959 23.3655 24.7759L23.2893 24.7069L15.9964 17.4139L8.70341 24.7069C8.31287 25.0972 7.67983 25.0973 7.28935 24.7069C6.89898 24.3164 6.899 23.6833 7.28935 23.2928L14.5823 15.9999L7.28935 8.7069C6.89898 8.31641 6.899 7.68334 7.28935 7.29284C7.67984 6.90235 8.31288 6.90242 8.70341 7.29284L15.9964 14.5858L23.2893 7.29284Z"
                fill="black" fill-opacity="0.48" />
            </g>
            <defs>
              <clipPath id="clip0_4123_9841">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h2 class="title-32_bold md-title-24_medium">实时报价深度</h2>
        <h3 class="body-16_regular md-footnote-regular_12">
          EBC 直连 25+ 顶级流动性，基于专业级 HUB 基础设施与智能订单路由（SOR）执行引擎，提供多档报价深度，实时透明呈现市场流动性层级。
        </h3>
        <div class="innerTableContainer" style="position: relative">
          <div class="fake-scrollbar mobile">
            <div class="fake-thumb"></div>
          </div>
          <div class="product-table" :class="{ 'grow-product-table': tabIndex == 3 || tabIndex == 4 }">
            <div class="product-table-row">
              <div class="product-innertable body-16_medium">
                <div class="product-innertable-th md-footnote-medium_12">
                  <div class="product-innertable-td">
                    layer
                    <span class="iconfont icon-a-tipsicon cursor-pointer" data-popover="p1"></span>
                  </div>
                  <div class="product-innertable-td">Bid</div>
                  <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                    Bid Volume
                  </div>
                  <div class="product-innertable-td">Ask</div>
                  <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                    Ask Volume
                  </div>
                  <div class="product-innertable-td">Spread</div>
                </div>
                <div class="product-innertable-tbody">
                  <div class="product-innertable-tr md-body-14_medium" v-for="(el, i) in innerTickList" :key="i">
                    <div class="product-innertable-td">{{ i + 1 }}</div>
                    <div class="product-innertable-td" :class="[el.bidClassName]">
                      {{ el.bid_price }}
                    </div>
                    <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                      {{ el.bid_size ? el.bid_size : "-" }}
                    </div>
                    <div class="product-innertable-td" :class="[el.askClassName]">
                      {{ el.ask_price }}
                    </div>
                    <div class="product-innertable-td" v-if="tabIndex != 3 && tabIndex != 4">
                      {{ el.ask_size ? el.ask_size : "-" }}
                    </div>
                    <div class="product-innertable-td">{{ el.spread }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="pageNavigation flex justify-center items-center">
        <span class="iconfont icon-a-down" :class="{ notAllow: targetNavigationIndex == 1 }"
          style="transform: rotate(90deg)" @click="targetNavigationIndex = targetNavigationIndex - 1"></span>
        <div v-for="item in visiblePages" class="md-footnote-regular_12"
          :class="targetNavigationIndex === item ? 'active' : ''" @click="setTargetNavigationIndex(item)">
          {{ (item === '+1' || item === '-1') ? '...' : item }}
        </div>
        <span class="iconfont icon-a-down" :class="{ notAllow: targetNavigationIndex == pageNavigationNumber }"
          style="transform: rotate(-90deg)" @click="targetNavigationIndex = targetNavigationIndex + 1"></span>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
const myEvent = new CustomEvent("mountedSuccess", {
  detail: true,
  bubbles: false,
  cancelable: true,
});
export default {
  name: "product-module-new",
  data() {
    return {
      msg: "测试",
      tabList: ["Forex", "Indices", "Commodities", "Stock CFDs", "ETF CFDs"],
      tableData: [
        {
          tabName: "Forex",
          datas: [
            { symbol: "EURUSD", tick: [], symbolZh: '欧元/美元', symbolFan: '歐元/美元' },
            { symbol: "AUDUSD", tick: [], symbolZh: '澳元/美元', symbolFan: '澳元/美元' },
            { symbol: "GBPUSD", tick: [], symbolZh: '英镑/美元', symbolFan: '英鎊/美元' },
            { symbol: "NZDUSD", tick: [], symbolZh: '纽元/美元', symbolFan: '紐元/美元' },
            { symbol: "USDCAD", tick: [], symbolZh: '美元/瑞郎', symbolFan: '美元/瑞郎' },
            { symbol: "USDJPY", tick: [], symbolZh: '美元/加元', symbolFan: '美元/加元' },
            { symbol: "USDCHF", tick: [], symbolZh: '美元/日元', symbolFan: '英鎊/日圓' },
            { symbol: "GBPAUD", tick: [], symbolZh: '英镑/澳元', symbolFan: '英鎊/澳元' },
            { symbol: "GBPJPY", tick: [], symbolZh: '英镑/日元', symbolFan: '英鎊/日圓' },
            { symbol: "AUDCAD", tick: [], symbolZh: '澳元/加元', symbolFan: '澳元/加元' },
            { symbol: "AUDCHF", tick: [], symbolZh: '澳元/瑞郎', symbolFan: '澳元/瑞郎' },
            { symbol: "AUDJPY", tick: [], symbolZh: '澳元/日元', symbolFan: '澳元/日圓' },
            { symbol: "AUDNZD", tick: [], symbolZh: '澳元/纽元', symbolFan: '澳元/紐元' },
            { symbol: "CADCHF", tick: [], symbolZh: '加元/瑞郎', symbolFan: '加元/瑞郎' },
            { symbol: "CADJPY", tick: [], symbolZh: '加元/日元', symbolFan: '加元/日圓' },
            { symbol: "CHFJPY", tick: [], symbolZh: '瑞郎/日元', symbolFan: '瑞郎/日圓' },
            { symbol: "EURAUD", tick: [], symbolZh: '欧元/澳元', symbolFan: '歐元/澳元' },
            { symbol: "EURCAD", tick: [], symbolZh: '欧元/加元', symbolFan: '歐元/加元' },
            { symbol: "EURCHF", tick: [], symbolZh: '欧元/瑞郎', symbolFan: '歐元/瑞郎' },
            { symbol: "EURGBP", tick: [], symbolZh: '欧元/英镑', symbolFan: '歐元/英鎊' },
            { symbol: "EURJPY", tick: [], symbolZh: '欧元/日元', symbolFan: '歐元/日圓' },
            { symbol: "EURNZD", tick: [], symbolZh: '欧元/纽元', symbolFan: '歐元/紐元' },
            { symbol: "GBPCAD", tick: [], symbolZh: '英镑/加元', symbolFan: '英鎊/加元' },
            { symbol: "GBPCHF", tick: [], symbolZh: '英镑/瑞郎', symbolFan: '英鎊/瑞郎' },
            { symbol: "GBPNZD", tick: [], symbolZh: '英镑/纽元', symbolFan: '英鎊/紐元' },
            { symbol: "NZDCAD", tick: [], symbolZh: '纽元/加元', symbolFan: '紐元/加元' },
            { symbol: "NZDCHF", tick: [], symbolZh: '纽元/瑞郎', symbolFan: '紐元/瑞郎' },
            { symbol: "NZDJPY", tick: [], symbolZh: '纽元/日元', symbolFan: '紐元/日圓' },
            { symbol: "USDCNH", tick: [], symbolZh: '美元/离岸人民币', symbolFan: '美元/離岸人民幣' },
            { symbol: "USDHKD", tick: [], symbolZh: '美元/港币', symbolFan: '美元/港元' },
            { symbol: "USDMXN", tick: [], symbolZh: '美元/墨西哥比索', symbolFan: '美元/墨西哥披索' },
            { symbol: "USDNOK", tick: [], symbolZh: '美元/挪威克朗', symbolFan: '美元/挪威克朗' },
          ],
        },
        {
          tabName: "Indices",
          datas: [
            { symbol: "100GBP", tick: [], symbolZh: '富时100指数', symbolFan: '富時100指數' },
            { symbol: "200AUD", tick: [], symbolZh: 'S&P200指数', symbolFan: 'S&P200指數' },
            { symbol: "225JPY", tick: [], symbolZh: '日经225指数', symbolFan: '日經225指數' },
            { symbol: "D30EUR", tick: [], symbolZh: 'DAX30指数', symbolFan: 'DAX30指數' },
            { symbol: "E50EUR", tick: [], symbolZh: 'STOXX50指数', symbolFan: 'STOXX50指數' },
            { symbol: "F40EUR", tick: [], symbolZh: 'CAC40指数', symbolFan: 'CAC40指數' },
            { symbol: "HSIHKD", tick: [], symbolZh: '恒生指数', symbolFan: '恒生指數' },
            { symbol: "NASUSD", tick: [], symbolZh: '纳斯达克指数', symbolFan: '納斯達克指數' },
            { symbol: "SPXUSD", tick: [], symbolZh: '标普500指数', symbolFan: '標普500指數' },
            { symbol: "U30USD", tick: [], symbolZh: '道琼斯指数', symbolFan: '道瓊斯指數' },
            { symbol: "CNIUSD", tick: [], symbolZh: '中国A50指数', symbolFan: '中國A50指數' },
            { symbol: "RUTUSD", tick: [], symbolZh: '罗素2000指数', symbolFan: '羅素2000指數' },
          ],
        },
        {
          tabName: "Commodities",
          datas: [
            { symbol: "XAUUSD", tick: [], symbolZh: '黄金/美元', symbolFan: '黃金/美元' },
            { symbol: "XAGUSD", tick: [], symbolZh: '白银/美元', symbolFan: '白銀/美元' },
            { symbol: "XBRUSD", tick: [], symbolZh: '布伦特原油', symbolFan: '布倫特原油' },
            { symbol: "XTIUSD", tick: [], symbolZh: 'WTI原油', symbolFan: 'WTI原油' },
            { symbol: "XNGUSD", tick: [], symbolZh: '天然气', symbolFan: '天然氣' },
          ],
        },
        {
          tabName: "Stock CFDs",
          datas: [
    { symbol: "SPCX", symbolEn: "SpaceX", symbolZh: "SpaceX", symbolFan: "SpaceX", tick: []},
    { symbol: "ABT", symbolEn: "Abbott Laboratories", symbolZh: "雅培", symbolFan: "雅培", tick: [],symbolEn:'Abbott Laboratories' },
    { symbol: "BA", symbolEn: "Boeing Co", symbolZh: "波音公司", symbolFan: "波音公司", tick: [],symbolEn:'Boeing Co' },
    { symbol: "BAC", symbolEn: "Bank of America Corp", symbolZh: "美国银行", symbolFan: "美國銀行", tick: [],symbolEn:'Bank of America Corp' },
    { symbol: "BMY", symbolEn: "Bristol-Myers Squibb Co", symbolZh: "百时美施贵宝公司", symbolFan: "百時美施貴寶公司", tick: [],symbolEn:'Bristol-Myers Squibb Co' },
    { symbol: "CAT", symbolEn: "Caterpillar Inc", symbolZh: "卡特彼勒公司", symbolFan: "卡特彼勒公司", tick: [],symbolEn:'Caterpillar Inc' },
    { symbol: "CRM", symbolEn: "Salesforce Inc", symbolZh: "Salesforce", symbolFan: "Salesforce", tick: [],symbolEn:'Salesforce Inc' },
    { symbol: "CVX", symbolEn: "Chevron Corp", symbolZh: "雪佛龙公司", symbolFan: "雪佛龍公司", tick: [],symbolEn:'Chevron Corp' },
    { symbol: "DIS", symbolEn: "Walt Disney Co", symbolZh: "华特迪士尼公司", symbolFan: "華特迪士尼公司", tick: [],symbolEn:'Walt Disney Co' },
    { symbol: "GE", symbolEn: "General Electric Co", symbolZh: "通用电气公司", symbolFan: "通用電氣公司", tick: [],symbolEn:'General Electric Co' },
    { symbol: "GS", symbolEn: "Goldman Sachs Group Inc", symbolZh: "高盛集团", symbolFan: "高盛集團", tick: [],symbolEn:'Goldman Sachs Group Inc' },
    { symbol: "HD", symbolEn: "Home Depot Inc", symbolZh: "家得宝公司", symbolFan: "家得寶公司", tick: [],symbolEn:'Home Depot Inc' },
    { symbol: "IBM", symbolEn: "International Business Machines Corp", symbolZh: "IBM", symbolFan: "IBM", tick: [],symbolEn:'International Business Machines Corp' },
    { symbol: "JNJ", symbolEn: "Johnson & Johnson", symbolZh: "强生公司", symbolFan: "強生公司", tick: [],symbolEn:'Johnson & Johnson' },
    { symbol: "JPM", symbolEn: "JPMorgan Chase", symbolZh: "摩根大通集团", symbolFan: "摩根大通集團", tick: [],symbolEn:'JPMorgan Chase' },
    { symbol: "KO", symbolEn: "Coca-Cola Co", symbolZh: "可口可乐公司", symbolFan: "可口可樂公司", tick: [],symbolEn:'Coca-Cola Co' },
    { symbol: "LLY", symbolEn: "Eli Lilly and Co", symbolZh: "礼来公司", symbolFan: "禮來公司", tick: [],symbolEn:'Eli Lilly and Co' },
    { symbol: "LMT", symbolEn: "Lockheed Martin Corp", symbolZh: "洛克希德马丁公司", symbolFan: "洛克希德馬丁公司", tick: [],symbolEn:'Lockheed Martin Corp' },
    { symbol: "MA", symbolEn: "Mastercard Inc", symbolZh: "万事达卡公司", symbolFan: "萬事達卡公司", tick: [],symbolEn:'Mastercard Inc' },
    { symbol: "MCD", symbolEn: "McDonald's Corp", symbolZh: "麦当劳", symbolFan: "麥當勞", tick: [],symbolEn:`McDonald's Corp` },
    { symbol: "MDT", symbolEn: "Medtronic plc", symbolZh: "美敦力公司", symbolFan: "美敦力公司", tick: [],symbolEn:'Medtronic plc' },
    { symbol: "MMM", symbolEn: "3M Co", symbolZh: "3M", symbolFan: "3M", tick: [],symbolEn:'3M Co' },
    { symbol: "MRK", symbolEn: "Merck & Co Inc", symbolZh: "默克公司", symbolFan: "默克公司", tick: [],symbolEn:'Merck & Co Inc' },
    { symbol: "MS", symbolEn: "Morgan Stanley", symbolZh: "摩根士丹利", symbolFan: "摩根士丹利", tick: [],symbolEn:'Morgan Stanley' },
    { symbol: "NEE", symbolEn: "NextEra Energy Inc", symbolZh: "NextEra 能源公司", symbolFan: "NextEra 能源公司", tick: [],symbolEn:'NextEra Energy Inc' },
    { symbol: "PFE", symbolEn: "Pfizer Inc", symbolZh: "辉瑞公司", symbolFan: "輝瑞公司", tick: [],symbolEn:'Pfizer Inc' },
    { symbol: "PG", symbolEn: "Procter & Gamble Co", symbolZh: "宝洁公司", symbolFan: "寶潔公司", tick: [],symbolEn:'Procter & Gamble Co' },
    { symbol: "RTX", symbolEn: "RTX Corp", symbolZh: "RTX", symbolFan: "RTX", tick: [],symbolEn:'RTX Corp' },
    { symbol: "UNH", symbolEn: "UnitedHealth Group Inc", symbolZh: "美国联合健康集团", symbolFan: "美國聯合健康集團", tick: [],symbolEn:'UnitedHealth Group Inc' },
    { symbol: "V", symbolEn: "Visa Inc", symbolZh: "Visa", symbolFan: "Visa", tick: [],symbolEn:'Visa Inc' },
    { symbol: "VZ", symbolEn: "Verizon Communications Inc", symbolZh: "威瑞森通信公司", symbolFan: "威瑞森通訊公司", tick: [],symbolEn:'Verizon Communications Inc' },
    { symbol: "WMT", symbolEn: "Walmart Inc", symbolZh: "沃尔玛公司", symbolFan: "沃爾瑪公司", tick: [],symbolEn:'Walmart Inc' },
    { symbol: "XOM", symbolEn: "Exxon Mobil Corp", symbolZh: "埃克森美孚公司", symbolFan: "埃克森美孚公司", tick: [],symbolEn:'Exxon Mobil Corp' },
    { symbol: "AAPL", symbolEn: "Apple Inc", symbolZh: "苹果公司", symbolFan: "蘋果公司", tick: [],symbolEn:'Apple Inc' },
    { symbol: "ADBE", symbolEn: "Adobe Inc", symbolZh: "Adobe", symbolFan: "Adobe", tick: [],symbolEn:'Adobe Inc' },
    { symbol: "AMGN", symbolEn: "Amgen Inc", symbolZh: "安进公司", symbolFan: "安進公司", tick: [],symbolEn:'Amgen Inc' },
    { symbol: "AMZN", symbolEn: "Amazon.com Inc", symbolZh: "亚马逊公司", symbolFan: "亞馬遜公司", tick: [],symbolEn:'Amazon.com Inc' },
    { symbol: "BRKb", symbolEn: "Berkshire Hathaway Inc", symbolZh: "伯克希尔哈撒韦公司", symbolFan: "伯克希爾哈撒韋公司", tick: [],symbolEn:'Berkshire Hathaway Inc' },
    { symbol: "CMCSA", symbolEn: "Comcast Corp", symbolZh: "康卡斯特公司", symbolFan: "康卡斯特公司", tick: [],symbolEn:'Comcast Corp' },
    { symbol: "CSCO", symbolEn: "Cisco Systems Inc", symbolZh: "思科", symbolFan: "思科", tick: [],symbolEn:'Cisco Systems Inc' },
    { symbol: "GOOGL", symbolEn: "Alphabet Inc - Class A", symbolZh: "谷歌A", symbolFan: "谷歌A", tick: [],symbolEn:'Alphabet Inc - Class A' },
    { symbol: "HON", symbolEn: "Honeywell International Inc", symbolZh: "霍尼韦尔国际公司", symbolFan: "霍尼韋爾國際公司", tick: [],symbolEn:'Honeywell International Inc' },
    { symbol: "INTC", symbolEn: "Intel Corp", symbolZh: "英特尔公司", symbolFan: "英特爾公司", tick: [],symbolEn:'Intel Corp' },
    { symbol: "META", symbolEn: "Meta Platforms Inc", symbolZh: "Meta公司", symbolFan: "Meta公司", tick: [],symbolEn:'Meta Platforms Inc' },
    { symbol: "MSFT", symbolEn: "Microsoft Corp", symbolZh: "微软公司", symbolFan: "微軟公司", tick: [],symbolEn:'Microsoft Corp' },
    { symbol: "NFLX", symbolEn: "Netflix Inc", symbolZh: "奈飞公司", symbolFan: "奈飛公司", tick: [],symbolEn:'Netflix Inc' },
    { symbol: "NVDA", symbolEn: "NVIDIA Corp", symbolZh: "英伟达公司", symbolFan: "英偉達公司", tick: [],symbolEn:'NVIDIA Corp' },
    { symbol: "PEP", symbolEn: "PepsiCo Inc", symbolZh: "百事公司", symbolFan: "百事公司", tick: [],symbolEn:'PepsiCo Inc' },
    { symbol: "PYPL", symbolEn: "PayPal Holdings Inc", symbolZh: "PayPal", symbolFan: "PayPal", tick: [],symbolEn:'PayPal Holdings Inc' },
    { symbol: "TSLA", symbolEn: "Tesla Inc", symbolZh: "特斯拉公司", symbolFan: "特斯拉公司", tick: [],symbolEn:'Tesla Inc' },
    { symbol: "TXN", symbolEn: "Texas Instruments Inc", symbolZh: "德州仪器公司", symbolFan: "德州儀器公司", tick: [],symbolEn:'Texas Instruments Inc' },
]
        },
        {
          tabName: "ETF CFDs",
          datas: [
        {
          "symbol": "AGG",
          "symbolEn": "iShares Core US Aggregate Bond ETF",
          "symbolZh": "美国全债市ETF-iShares",
          "symbolFan": "美國全債市ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "1380.26",
          "returns": {
            "total_return": "-3.32%",
            "10y": "-11.85%",
            "5y": "-14.29%",
            "3y": "0.93%",
            "1y": "0.67%"
          },
          "betas": {
            "beta_5y": "0.25%",
            "beta_3y": "0.21%",
            "beta_1y": "0.11%"
          }
        },
        {
          "symbol": "BIL",
          "symbolEn": "SPDR Bloomberg Barclays 1-3 Month T-Bill ETF",
          "symbolZh": "1-3月美国国债ETF-SPDR",
          "symbolFan": "1-3月美國國債ETF-SPDR",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "468.29",
          "returns": {
            "total_return": "-0.05%",
            "10y": "0.12%",
            "5y": "0.07%",
            "3y": "-0.13%",
            "1y": "-0.07%"
          },
          "betas": {
            "beta_5y": "0.00%",
            "beta_3y": "0.00%",
            "beta_1y": "0.01%"
          }
        },
        {
          "symbol": "BSV",
          "symbolEn": "Vanguard Short-Term Bond Index Fund",
          "symbolZh": "美国短期债券ETF-Vanguard",
          "symbolFan": "美國短期債券ETF-Vanguard",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "444.80",
          "returns": {
            "total_return": "3.60%",
            "10y": "-4.00%",
            "5y": "-5.41%",
            "3y": "3.03%",
            "1y": "-0.60%"
          },
          "betas": {
            "beta_5y": "0.09%",
            "beta_3y": "0.05%",
            "beta_1y": "0.05%"
          }
        },
        {
          "symbol": "DGRO",
          "symbolEn": "iShares Core Dividend Growth ETF",
          "symbolZh": "安硕核心股利增长ETF",
          "symbolFan": "安碩核心股利增長ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "409.31",
          "returns": {
            "total_return": "202.38%",
            "10y": "178.98%",
            "5y": "51.80%",
            "3y": "45.91%",
            "1y": "19.91%"
          },
          "betas": {
            "beta_5y": "0.78%",
            "beta_3y": "0.71%",
            "beta_1y": "0.59%"
          }
        },
        {
          "symbol": "DIA",
          "symbolEn": "SPDR Dow Jones Industrial Average ETF Trust",
          "symbolZh": "道琼斯指数ETF-SPDR",
          "symbolFan": "道瓊斯指數ETF-SPDR",
          "tick": [],
          "focus": "大盘",
          "fundSize": "457.94",
          "returns": {
            "total_return": "563.52%",
            "10y": "191.45%",
            "5y": "54.42%",
            "3y": "52.05%",
            "1y": "21.64%"
          },
          "betas": {
            "beta_5y": "0.87%",
            "beta_3y": "0.85%",
            "beta_1y": "0.84%"
          }
        },
        {
          "symbol": "EEM",
          "symbolEn": "iShares MSCI Emerging Markets ETF (USD)",
          "symbolZh": "新兴市场ETF-iShares",
          "symbolFan": "新興市場ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "308.21",
          "returns": {
            "total_return": "516.31%",
            "10y": "106.26%",
            "5y": "26.08%",
            "3y": "67.46%",
            "1y": "46.15%"
          },
          "betas": {
            "beta_5y": "0.73%",
            "beta_3y": "0.80%",
            "beta_1y": "1.29%"
          }
        },
        {
          "symbol": "EFA",
          "symbolEn": "iShares MSCI EAFE ETF (USD)",
          "symbolZh": "欧澳远东指数ETF-iShares",
          "symbolFan": "歐澳遠東指數ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "779.08",
          "returns": {
            "total_return": "147.10%",
            "10y": "84.99%",
            "5y": "31.82%",
            "3y": "41.10%",
            "1y": "18.38%"
          },
          "betas": {
            "beta_5y": "0.77%",
            "beta_3y": "0.61%",
            "beta_1y": "0.97%"
          }
        },
        {
          "symbol": "EWT",
          "symbolEn": "iShares MSCI TAIWAN ETF",
          "symbolZh": "安硕MSCI台湾ETF",
          "symbolFan": "安碩MSCI台灣ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "110.26",
          "returns": {
            "total_return": "171.25%",
            "10y": "285.02%",
            "5y": "67.53%",
            "3y": "117.85%",
            "1y": "87.60%"
          },
          "betas": {
            "beta_5y": "1.16%",
            "beta_3y": "1.26%",
            "beta_1y": "1.50%"
          }
        },
        {
          "symbol": "EWW",
          "symbolEn": "iShares MSCI Mexico ETF",
          "symbolZh": "墨西哥投资指数ETF-iShares MSCI",
          "symbolFan": "墨西哥投資指數ETF-iShares MSCI",
          "tick": [],
          "focus": "总市场",
          "fundSize": "19.49",
          "returns": {
            "total_return": "645.16%",
            "10y": "59.17%",
            "5y": "65.44%",
            "3y": "20.92%",
            "1y": "30.37%"
          },
          "betas": {
            "beta_5y": "0.78%",
            "beta_3y": "0.60%",
            "beta_1y": "0.94%"
          }
        },
        {
          "symbol": "EWY",
          "symbolEn": "iShares MSCI SOUTH KOREA ETF",
          "symbolZh": "韩国ETF-iShares MSCI",
          "symbolFan": "韓國ETF-iShares MSCI",
          "tick": [],
          "focus": "总市场",
          "fundSize": "250.43",
          "returns": {
            "total_return": "944.99%",
            "10y": "304.74%",
            "5y": "124.03%",
            "3y": "207.06%",
            "1y": "203.51%"
          },
          "betas": {
            "beta_5y": "1.46%",
            "beta_3y": "1.74%",
            "beta_1y": "2.22%"
          }
        },
        {
          "symbol": "EWZ",
          "symbolEn": "iShares MSCI BRAZIL ETF",
          "symbolZh": "巴西ETF-iShares",
          "symbolFan": "巴西ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "92.23",
          "returns": {
            "total_return": "81.92%",
            "10y": "24.22%",
            "5y": "-16.15%",
            "3y": "5.73%",
            "1y": "20.53%"
          },
          "betas": {
            "beta_5y": "0.64%",
            "beta_3y": "0.45%",
            "beta_1y": "0.88%"
          }
        },
        {
          "symbol": "FVD",
          "symbolEn": "First Trust Value Line Dividend Index Fund",
          "symbolZh": "第一信托超值系列红利指数基金",
          "symbolFan": "第一信託超值系列紅利指數基金",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "80.56",
          "returns": {
            "total_return": "217.53%",
            "10y": "80.35%",
            "5y": "19.91%",
            "3y": "19.33%",
            "1y": "6.96%"
          },
          "betas": {
            "beta_5y": "0.65%",
            "beta_3y": "0.53%",
            "beta_1y": "0.36%"
          }
        },
        {
          "symbol": "FXI",
          "symbolEn": "iShares CHINA LARGE-CAP ETF",
          "symbolZh": "中国大盘股ETF-iShares",
          "symbolFan": "中國大盤股ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "51.90",
          "returns": {
            "total_return": "87.99%",
            "10y": "2.59%",
            "5y": "-26.29%",
            "3y": "17.37%",
            "1y": "-7.81%"
          },
          "betas": {
            "beta_5y": "0.30%",
            "beta_3y": "0.29%",
            "beta_1y": "0.95%"
          }
        },
        {
          "symbol": "GDX",
          "symbolEn": "VanEck Vectors Gold Miners ETF",
          "symbolZh": "黄金矿业ETF-VanEck",
          "symbolFan": "黃金礦業ETF-VanEck",
          "tick": [],
          "focus": "材料",
          "fundSize": "259.32",
          "returns": {
            "total_return": "131.00%",
            "10y": "225.09%",
            "5y": "142.14%",
            "3y": "177.65%",
            "1y": "56.83%"
          },
          "betas": {
            "beta_5y": "0.61%",
            "beta_3y": "0.18%",
            "beta_1y": "1.63%"
          }
        },
        {
          "symbol": "GDXJ",
          "symbolEn": "VanEck Junior Gold Miners ETF",
          "symbolZh": "小型黄金矿业ETF-VanEck",
          "symbolFan": "小型黃金礦業ETF-VanEck",
          "tick": [],
          "focus": "材料",
          "fundSize": "81.39",
          "returns": {
            "total_return": "5.57%",
            "10y": "171.56%",
            "5y": "125.03%",
            "3y": "207.65%",
            "1y": "56.85%"
          },
          "betas": {
            "beta_5y": "0.80%",
            "beta_3y": "0.29%",
            "beta_1y": "1.93%"
          }
        },
        {
          "symbol": "GLD",
          "symbolEn": "SPDR Gold Shares ETF",
          "symbolZh": "黄金ETF-SPDR",
          "symbolFan": "黃金ETF-SPDR",
          "tick": [],
          "focus": "黄金",
          "fundSize": "1411.97",
          "returns": {
            "total_return": "774.63%",
            "10y": "215.27%",
            "5y": "133.90%",
            "3y": "118.96%",
            "1y": "24.29%"
          },
          "betas": {
            "beta_5y": "0.14%",
            "beta_3y": "-0.08%",
            "beta_1y": "0.53%"
          }
        },
        {
          "symbol": "HDV",
          "symbolEn": "iShares Core High Dividend ETF",
          "symbolZh": "iShares安硕核心高股息ETF",
          "symbolFan": "iShares安碩核心高股息ETF",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "135.43",
          "returns": {
            "total_return": "167.04%",
            "10y": "67.39%",
            "5y": "41.57%",
            "3y": "33.56%",
            "1y": "15.84%"
          },
          "betas": {
            "beta_5y": "0.55%",
            "beta_3y": "0.35%",
            "beta_1y": "0.06%"
          }
        },
        {
          "symbol": "HYG",
          "symbolEn": "iShares iBoxx $ High Yield Corporate Bond Fund",
          "symbolZh": "债券指数ETF-iShares iBoxx高收益公司债",
          "symbolFan": "債券指數ETF-iShares iBoxx高收益公司債",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "164.19",
          "returns": {
            "total_return": "-23.59%",
            "10y": "-4.04%",
            "5y": "-8.71%",
            "3y": "6.81%",
            "1y": "0.26%"
          },
          "betas": {
            "beta_5y": "0.40%",
            "beta_3y": "0.27%",
            "beta_1y": "0.23%"
          }
        },
        {
          "symbol": "IEMG",
          "symbolEn": "iShares Core MSCI Emerging Mkts ETF",
          "symbolZh": "核心MSCI新兴市场ETF-iShares",
          "symbolFan": "核心MSCI新興市場ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "1635.76",
          "returns": {
            "total_return": "68.64%",
            "10y": "107.60%",
            "5y": "25.67%",
            "3y": "64.14%",
            "1y": "42.35%"
          },
          "betas": {
            "beta_5y": "0.73%",
            "beta_3y": "0.80%",
            "beta_1y": "1.27%"
          }
        },
        {
          "symbol": "IJH",
          "symbolEn": "iShares S&P Midcap 400 Index Fund",
          "symbolZh": "标普中型股指数ETF-iShares",
          "symbolFan": "標普中型股指數ETF-iShares",
          "tick": [],
          "focus": "中盘",
          "fundSize": "1221.63",
          "returns": {
            "total_return": "720.57%",
            "10y": "153.43%",
            "5y": "43.06%",
            "3y": "45.73%",
            "1y": "24.22%"
          },
          "betas": {
            "beta_5y": "1.02%",
            "beta_3y": "1.06%",
            "beta_1y": "0.85%"
          }
        },
        {
          "symbol": "IJR",
          "symbolEn": "iShares Core S&P Small-Cap ETF",
          "symbolZh": "标普小盘股指数ETF-iShares",
          "symbolFan": "標普小盤股指數ETF-iShares",
          "tick": [],
          "focus": "小盘",
          "fundSize": "1071.44",
          "returns": {
            "total_return": "778.34%",
            "10y": "143.10%",
            "5y": "27.26%",
            "3y": "42.59%",
            "1y": "32.63%"
          },
          "betas": {
            "beta_5y": "1.03%",
            "beta_3y": "1.15%",
            "beta_1y": "0.94%"
          }
        },
        {
          "symbol": "ITOT",
          "symbolEn": "iShares Trust S & P 1500",
          "symbolZh": "标普全美股市ETF-iShares",
          "symbolFan": "標普全美股市ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "936.23",
          "returns": {
            "total_return": "543.89%",
            "10y": "241.48%",
            "5y": "68.19%",
            "3y": "67.16%",
            "1y": "24.00%"
          },
          "betas": {
            "beta_5y": "1.02%",
            "beta_3y": "1.04%",
            "beta_1y": "1.01%"
          }
        },
        {
          "symbol": "IVE",
          "symbolEn": "iShares S&P 500 Value ETF",
          "symbolZh": "标普500价值指数ETF-iShares",
          "symbolFan": "標普500價值指數ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "478.75",
          "returns": {
            "total_return": "278.78%",
            "10y": "145.10%",
            "5y": "56.00%",
            "3y": "40.98%",
            "1y": "18.26%"
          },
          "betas": {
            "beta_5y": "0.83%",
            "beta_3y": "0.82%",
            "beta_1y": "0.68%"
          }
        },
        {
          "symbol": "IVV",
          "symbolEn": "iShares Core S&P 500 ETF (USD)",
          "symbolZh": "标普500ETF-iShares",
          "symbolFan": "標普500ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "8110.40",
          "returns": {
            "total_return": "420.56%",
            "10y": "254.77%",
            "5y": "77.25%",
            "3y": "68.17%",
            "1y": "23.50%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.01%",
            "beta_1y": "1.01%"
          }
        },
        {
          "symbol": "IVW",
          "symbolEn": "iShares S&P 500 Growth ETF",
          "symbolZh": "标普500成长股指数ETF-iShares",
          "symbolFan": "標普500成長股指數ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "753.92",
          "returns": {
            "total_return": "570.02%",
            "10y": "366.45%",
            "5y": "92.65%",
            "3y": "94.68%",
            "1y": "28.24%"
          },
          "betas": {
            "beta_5y": "1.18%",
            "beta_3y": "1.19%",
            "beta_1y": "1.28%"
          }
        },
        {
          "symbol": "IWB",
          "symbolEn": "iShares Russell 1000 ETF",
          "symbolZh": "罗素1000指数ETF-iShares",
          "symbolFan": "羅素1000指數ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "486.34",
          "returns": {
            "total_return": "435.87%",
            "10y": "249.10%",
            "5y": "71.12%",
            "3y": "67.34%",
            "1y": "22.88%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.02%",
            "beta_1y": "0.99%"
          }
        },
        {
          "symbol": "IWD",
          "symbolEn": "iShares Russell 1000 Value ETF",
          "symbolZh": "罗素1000价值指数ETF-iShares",
          "symbolFan": "羅素1000價值指數ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "771.62",
          "returns": {
            "total_return": "333.12%",
            "10y": "136.41%",
            "5y": "54.37%",
            "3y": "53.48%",
            "1y": "26.71%"
          },
          "betas": {
            "beta_5y": "0.85%",
            "beta_3y": "0.84%",
            "beta_1y": "0.72%"
          }
        },
        {
          "symbol": "IWF",
          "symbolEn": "iShares Russell 1000 Growth ETF",
          "symbolZh": "罗素1000成长指数ETF-iShares",
          "symbolFan": "羅素1000成長指數ETF-iShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "1281.73",
          "returns": {
            "total_return": "522.09%",
            "10y": "386.94%",
            "5y": "85.04%",
            "3y": "78.63%",
            "1y": "19.19%"
          },
          "betas": {
            "beta_5y": "1.17%",
            "beta_3y": "1.18%",
            "beta_1y": "1.25%"
          }
        },
        {
          "symbol": "IWM",
          "symbolEn": "iShares Russell 2000 ETF",
          "symbolZh": "罗素2000ETF-iShares",
          "symbolFan": "羅素2000ETF-iShares",
          "tick": [],
          "focus": "小盘",
          "fundSize": "824.68",
          "returns": {
            "total_return": "536.66%",
            "10y": "153.37%",
            "5y": "29.58%",
            "3y": "55.81%",
            "1y": "38.66%"
          },
          "betas": {
            "beta_5y": "1.12%",
            "beta_3y": "1.30%",
            "beta_1y": "1.12%"
          }
        },
        {
          "symbol": "IWN",
          "symbolEn": "iShares Russell 2000 Value ETF",
          "symbolZh": "罗素2000价值股指数ETF-iShares",
          "symbolFan": "羅素2000價值股指數ETF-iShares",
          "tick": [],
          "focus": "小盘",
          "fundSize": "142.81",
          "returns": {
            "total_return": "526.20%",
            "10y": "121.14%",
            "5y": "29.88%",
            "3y": "52.09%",
            "1y": "39.31%"
          },
          "betas": {
            "beta_5y": "1.03%",
            "beta_3y": "1.13%",
            "beta_1y": "0.97%"
          }
        },
        {
          "symbol": "IWS",
          "symbolEn": "iShares Russell Mid-Cap Value ETF",
          "symbolZh": "罗素中型价值股指数ETF-iShares",
          "symbolFan": "羅素中型價值股指數ETF-iShares",
          "tick": [],
          "focus": "中盘",
          "fundSize": "156.30",
          "returns": {
            "total_return": "532.73%",
            "10y": "120.74%",
            "5y": "43.43%",
            "3y": "48.80%",
            "1y": "25.26%"
          },
          "betas": {
            "beta_5y": "0.96%",
            "beta_3y": "0.97%",
            "beta_1y": "0.73%"
          }
        },
        {
          "symbol": "LQD",
          "symbolEn": "iShares iBoxx $ Investment Grade Corporate Bond ETF",
          "symbolZh": "债券指数ETF-iShares iBoxx投资级公司债",
          "symbolFan": "債券指數ETF-iShares iBoxx投資級公司債",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "309.50",
          "returns": {
            "total_return": "5.86%",
            "10y": "-10.17%",
            "5y": "-18.76%",
            "3y": "1.59%",
            "1y": "0.82%"
          },
          "betas": {
            "beta_5y": "0.44%",
            "beta_3y": "0.36%",
            "beta_1y": "0.20%"
          }
        },
        {
          "symbol": "MDY",
          "symbolEn": "SPDR S&P Midcap 400 ETF",
          "symbolZh": "标普中型股400指数ETF-SPDR",
          "symbolFan": "標普中型股400指數ETF-SPDR",
          "tick": [],
          "focus": "中盘",
          "fundSize": "272.47",
          "returns": {
            "total_return": "1721.40%",
            "10y": "155.07%",
            "5y": "43.27%",
            "3y": "45.62%",
            "1y": "24.09%"
          },
          "betas": {
            "beta_5y": "1.02%",
            "beta_3y": "1.05%",
            "beta_1y": "0.84%"
          }
        },
        {
          "symbol": "RSP",
          "symbolEn": "Invesco S&P 500 Eql Wght ETF",
          "symbolZh": "平均加权指数ETF-Rydex S&P",
          "symbolFan": "平均加權指數ETF-Rydex S&P",
          "tick": [],
          "focus": "大盘",
          "fundSize": "930.28",
          "returns": {
            "total_return": "719.97%",
            "10y": "162.85%",
            "5y": "41.32%",
            "3y": "42.62%",
            "1y": "17.20%"
          },
          "betas": {
            "beta_5y": "0.92%",
            "beta_3y": "0.90%",
            "beta_1y": "0.71%"
          }
        },
        {
          "symbol": "SCHB",
          "symbolEn": "Schwab US Broad Market ETF",
          "symbolZh": "嘉信美国整体市场ETF",
          "symbolFan": "嘉信美國整體市場ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "433.57",
          "returns": {
            "total_return": "587.84%",
            "10y": "243.51%",
            "5y": "68.62%",
            "3y": "69.17%",
            "1y": "23.85%"
          },
          "betas": {
            "beta_5y": "1.03%",
            "beta_3y": "1.04%",
            "beta_1y": "1.00%"
          }
        },
        {
          "symbol": "SCHD",
          "symbolEn": "Schwab US Dividend Equity ETF",
          "symbolZh": "美国红利股ETF-Schwab",
          "symbolFan": "美國紅利股ETF-Schwab",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "970.20",
          "returns": {
            "total_return": "283.16%",
            "10y": "133.86%",
            "5y": "28.11%",
            "3y": "33.01%",
            "1y": "18.74%"
          },
          "betas": {
            "beta_5y": "0.69%",
            "beta_3y": "0.60%",
            "beta_1y": "0.36%"
          }
        },
        {
          "symbol": "SCHF",
          "symbolEn": "Schwab International Equity ETF",
          "symbolZh": "嘉信国际股票ETF",
          "symbolFan": "嘉信國際股票ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "669.55",
          "returns": {
            "total_return": "130.65%",
            "10y": "108.83%",
            "5y": "40.94%",
            "3y": "54.01%",
            "1y": "28.01%"
          },
          "betas": {
            "beta_5y": "0.82%",
            "beta_3y": "0.72%",
            "beta_1y": "1.04%"
          }
        },
        {
          "symbol": "SCHG",
          "symbolEn": "Schwab US Large-Cap Growth ETF",
          "symbolZh": "嘉信美国大盘股成长型ETF",
          "symbolFan": "嘉信美國大盤股成長型ETF",
          "tick": [],
          "focus": "大盘",
          "fundSize": "596.50",
          "returns": {
            "total_return": "953.03%",
            "10y": "409.28%",
            "5y": "89.01%",
            "3y": "83.36%",
            "1y": "19.07%"
          },
          "betas": {
            "beta_5y": "1.20%",
            "beta_3y": "1.20%",
            "beta_1y": "1.27%"
          }
        },
        {
          "symbol": "SCHX",
          "symbolEn": "Schwab US Large-Cap ETF",
          "symbolZh": "嘉信理财美国大盘股ETF",
          "symbolFan": "嘉信理財美國大盤股ETF",
          "tick": [],
          "focus": "大盘",
          "fundSize": "724.26",
          "returns": {
            "total_return": "620.15%",
            "10y": "253.60%",
            "5y": "72.42%",
            "3y": "70.01%",
            "1y": "22.91%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.02%",
            "beta_1y": "1.00%"
          }
        },
        {
          "symbol": "SDY",
          "symbolEn": "SPDR S&P Dividend ETF",
          "symbolZh": "股息指数ETF-SPDR S&P",
          "symbolFan": "股息指數ETF-SPDR S&P",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "214.81",
          "returns": {
            "total_return": "177.11%",
            "10y": "83.68%",
            "5y": "23.75%",
            "3y": "24.05%",
            "1y": "11.49%"
          },
          "betas": {
            "beta_5y": "0.71%",
            "beta_3y": "0.62%",
            "beta_1y": "0.38%"
          }
        },
        {
          "symbol": "SPDW",
          "symbolEn": "SPDR Portfolio Developed World ex-US ETF",
          "symbolZh": "SPDR投资组合发达世界(美国除外)ETF",
          "symbolFan": "SPDR投資組合發達世界(美國除外)ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "411.85",
          "returns": {
            "total_return": "57.06%",
            "10y": "108.20%",
            "5y": "37.96%",
            "3y": "53.82%",
            "1y": "27.18%"
          },
          "betas": {
            "beta_5y": "0.83%",
            "beta_3y": "0.70%",
            "beta_1y": "0.98%"
          }
        },
        {
          "symbol": "SPY",
          "symbolEn": "SPDR S&P 500 ETF Trust",
          "symbolZh": "标普500ETF-SPDR",
          "symbolFan": "標普500ETF-SPDR",
          "tick": [],
          "focus": "大盘",
          "fundSize": "7915.63",
          "returns": {
            "total_return": "1585.19%",
            "10y": "257.66%",
            "5y": "77.65%",
            "3y": "70.76%",
            "1y": "23.45%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.01%",
            "beta_1y": "1.00%"
          }
        },
        {
          "symbol": "SPYG",
          "symbolEn": "SPDR Portfolio S&P 500 Growth ETF",
          "symbolZh": "SPDR Portfolio S&P 500 Growth ETF",
          "symbolFan": "SPDR Portfolio S&P 500 Growth ETF",
          "tick": [],
          "focus": "大盘",
          "fundSize": "532.55",
          "returns": {
            "total_return": "383.35%",
            "10y": "369.14%",
            "5y": "92.36%",
            "3y": "96.46%",
            "1y": "28.28%"
          },
          "betas": {
            "beta_5y": "1.18%",
            "beta_3y": "1.18%",
            "beta_1y": "1.28%"
          }
        },
        {
          "symbol": "SPYV",
          "symbolEn": "SPDR Portfolio S&P 500 Value ETF",
          "symbolZh": "SPDR Portfolio S&P 500 Value ETF",
          "symbolFan": "SPDR Portfolio S&P 500 Value ETF",
          "tick": [],
          "focus": "大盘",
          "fundSize": "355.05",
          "returns": {
            "total_return": "268.64%",
            "10y": "145.30%",
            "5y": "55.62%",
            "3y": "42.80%",
            "1y": "18.19%"
          },
          "betas": {
            "beta_5y": "0.83%",
            "beta_3y": "0.81%",
            "beta_1y": "0.67%"
          }
        },
        {
          "symbol": "TIP",
          "symbolEn": "iShares TIPS Bond ETF",
          "symbolZh": "通胀债券指数ETF-iShares",
          "symbolFan": "通脹債券指數ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "149.35",
          "returns": {
            "total_return": "7.42%",
            "10y": "-5.78%",
            "5y": "-14.14%",
            "3y": "1.25%",
            "1y": "0.32%"
          },
          "betas": {
            "beta_5y": "0.28%",
            "beta_3y": "0.14%",
            "beta_1y": "0.11%"
          }
        },
        {
          "symbol": "UNG",
          "symbolEn": "United States Natural Gas Fund ETF",
          "symbolZh": "美国天然气ETF",
          "symbolFan": "美國天然氣ETF",
          "tick": [],
          "focus": "天然气",
          "fundSize": "4.44",
          "returns": {
            "total_return": "-99.82%",
            "10y": "-90.75%",
            "5y": "-74.40%",
            "3y": "-60.53%",
            "1y": "-33.39%"
          },
          "betas": {
            "beta_5y": "0.08%",
            "beta_3y": "-0.31%",
            "beta_1y": "-0.44%"
          }
        },
        {
          "symbol": "URA",
          "symbolEn": "Global X Uranium ETF",
          "symbolZh": "铀价ETF-Global X",
          "symbolFan": "鈾價ETF-Global X",
          "tick": [],
          "focus": "主题",
          "fundSize": "66.52",
          "returns": {
            "total_return": "-54.47%",
            "10y": "225.50%",
            "5y": "122.80%",
            "3y": "112.62%",
            "1y": "23.56%"
          },
          "betas": {
            "beta_5y": "1.09%",
            "beta_3y": "1.15%",
            "beta_1y": "1.91%"
          }
        },
        {
          "symbol": "USO",
          "symbolEn": "United States Oil Fund LP ETF",
          "symbolZh": "美国原油ETF",
          "symbolFan": "美國原油ETF",
          "tick": [],
          "focus": "原油",
          "fundSize": "18.29",
          "returns": {
            "total_return": "-79.08%",
            "10y": "24.71%",
            "5y": "138.73%",
            "3y": "78.92%",
            "1y": "42.01%"
          },
          "betas": {
            "beta_5y": "-0.03%",
            "beta_3y": "-0.53%",
            "beta_1y": "-1.30%"
          }
        },
        {
          "symbol": "VB",
          "symbolEn": "Vanguard Small-Cap ETF",
          "symbolZh": "小盘股ETF-Vanguard",
          "symbolFan": "小盤股ETF-Vanguard",
          "tick": [],
          "focus": "小盘",
          "fundSize": "841.57",
          "returns": {
            "total_return": "499.69%",
            "10y": "155.80%",
            "5y": "32.97%",
            "3y": "50.37%",
            "1y": "26.89%"
          },
          "betas": {
            "beta_5y": "1.06%",
            "beta_3y": "1.15%",
            "beta_1y": "0.93%"
          }
        },
        {
          "symbol": "VDE",
          "symbolEn": "Vanguard Energy ETF",
          "symbolZh": "能源指数ETF-Vanguard",
          "symbolFan": "能源指數ETF-Vanguard",
          "tick": [],
          "focus": "能源",
          "fundSize": "94.92",
          "returns": {
            "total_return": "206.29%",
            "10y": "64.79%",
            "5y": "108.23%",
            "3y": "38.99%",
            "1y": "23.89%"
          },
          "betas": {
            "beta_5y": "0.44%",
            "beta_3y": "0.05%",
            "beta_1y": "-0.62%"
          }
        },
        {
          "symbol": "VEA",
          "symbolEn": "Vanguard FTSE Developed Markets ETF",
          "symbolZh": "富时成熟市场ETF-Vanguard",
          "symbolFan": "富時成熟市場ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "2330.62",
          "returns": {
            "total_return": "48.51%",
            "10y": "106.01%",
            "5y": "39.29%",
            "3y": "52.99%",
            "1y": "28.09%"
          },
          "betas": {
            "beta_5y": "0.84%",
            "beta_3y": "0.73%",
            "beta_1y": "1.05%"
          }
        },
        {
          "symbol": "VEU",
          "symbolEn": "Vanguard FTSE All World ex US Index Fund Investor Shares",
          "symbolZh": "富时全球(除美国)ETF-Vanguard",
          "symbolFan": "富時全球(除美國)ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "674.43",
          "returns": {
            "total_return": "66.26%",
            "10y": "100.55%",
            "5y": "32.71%",
            "3y": "51.24%",
            "1y": "27.20%"
          },
          "betas": {
            "beta_5y": "0.77%",
            "beta_3y": "0.70%",
            "beta_1y": "1.04%"
          }
        },
        {
          "symbol": "VGT",
          "symbolEn": "Vanguard Information Technology ETF",
          "symbolZh": "资讯科技ETF-Vanguard",
          "symbolFan": "資訊科技ETF-Vanguard",
          "tick": [],
          "focus": "信息技术",
          "fundSize": "1475.53",
          "returns": {
            "total_return": "1819.24%",
            "10y": "764.15%",
            "5y": "142.78%",
            "3y": "114.24%",
            "1y": "48.32%"
          },
          "betas": {
            "beta_5y": "1.35%",
            "beta_3y": "1.47%",
            "beta_1y": "1.47%"
          }
        },
        {
          "symbol": "VHT",
          "symbolEn": "Vanguard Health Care ETF",
          "symbolZh": "健康护理股ETF-Vanguard",
          "symbolFan": "健康護理股ETF-Vanguard",
          "tick": [],
          "focus": "卫生保健",
          "fundSize": "169.47",
          "returns": {
            "total_return": "465.45%",
            "10y": "117.82%",
            "5y": "15.97%",
            "3y": "16.59%",
            "1y": "13.61%"
          },
          "betas": {
            "beta_5y": "0.62%",
            "beta_3y": "0.56%",
            "beta_1y": "0.51%"
          }
        },
        {
          "symbol": "VIG",
          "symbolEn": "Vanguard Dividend Appreciation Index Fund",
          "symbolZh": "递增股利ETF-Vanguard",
          "symbolFan": "遞增股利ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "1096.07",
          "returns": {
            "total_return": "371.77%",
            "10y": "185.17%",
            "5y": "54.41%",
            "3y": "46.93%",
            "1y": "17.07%"
          },
          "betas": {
            "beta_5y": "0.83%",
            "beta_3y": "0.78%",
            "beta_1y": "0.72%"
          }
        },
        {
          "symbol": "VNQ",
          "symbolEn": "Vanguard Real Estate Index Fund",
          "symbolZh": "不动产信托指数ETF-Vanguard",
          "symbolFan": "不動產信託指數ETF-Vanguard",
          "tick": [],
          "focus": "房地产",
          "fundSize": "383.25",
          "returns": {
            "total_return": "91.80%",
            "10y": "11.39%",
            "5y": "-7.19%",
            "3y": "16.77%",
            "1y": "6.36%"
          },
          "betas": {
            "beta_5y": "1.00%",
            "beta_3y": "0.94%",
            "beta_1y": "0.58%"
          }
        },
        {
          "symbol": "VO",
          "symbolEn": "Vanguard Mid-Cap ETF",
          "symbolZh": "中盘股ETF-Vanguard",
          "symbolFan": "中盤股ETF-Vanguard",
          "tick": [],
          "focus": "中盘",
          "fundSize": "1125.58",
          "returns": {
            "total_return": "547.98%",
            "10y": "159.89%",
            "5y": "36.91%",
            "3y": "48.14%",
            "1y": "16.75%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.00%",
            "beta_1y": "0.72%"
          }
        },
        {
          "symbol": "VOE",
          "symbolEn": "Vanguard Mid-Cap Value Index Fund",
          "symbolZh": "中盘价值股ETF-Vanguard",
          "symbolFan": "中盤價值股ETF-Vanguard",
          "tick": [],
          "focus": "中盘",
          "fundSize": "238.06",
          "returns": {
            "total_return": "286.56%",
            "10y": "121.88%",
            "5y": "40.74%",
            "3y": "44.88%",
            "1y": "20.61%"
          },
          "betas": {
            "beta_5y": "0.86%",
            "beta_3y": "0.82%",
            "beta_1y": "0.52%"
          }
        },
        {
          "symbol": "VOO",
          "symbolEn": "Vanguard S&P 500 ETF",
          "symbolZh": "标普500ETF-Vanguard",
          "symbolFan": "標普500ETF-Vanguard",
          "tick": [],
          "focus": "大盘",
          "fundSize": "10471.58",
          "returns": {
            "total_return": "564.79%",
            "10y": "256.57%",
            "5y": "77.09%",
            "3y": "70.22%",
            "1y": "23.49%"
          },
          "betas": {
            "beta_5y": "1.01%",
            "beta_3y": "1.01%",
            "beta_1y": "1.00%"
          }
        },
        {
          "symbol": "VT",
          "symbolEn": "Vanguard Total World Stock Index Fund",
          "symbolZh": "全球股市指数ETF-Vanguard",
          "symbolFan": "全球股市指數ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "780.02",
          "returns": {
            "total_return": "213.32%",
            "10y": "172.54%",
            "5y": "52.98%",
            "3y": "61.51%",
            "1y": "24.56%"
          },
          "betas": {
            "beta_5y": "0.93%",
            "beta_3y": "0.91%",
            "beta_1y": "1.02%"
          }
        },
        {
          "symbol": "VTI",
          "symbolEn": "Vanguard Total Stock Market ETF",
          "symbolZh": "整体股市指数ETF-Vanguard",
          "symbolFan": "整體股市指數ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "6673.17",
          "returns": {
            "total_return": "538.88%",
            "10y": "244.67%",
            "5y": "67.79%",
            "3y": "68.88%",
            "1y": "23.94%"
          },
          "betas": {
            "beta_5y": "1.02%",
            "beta_3y": "1.04%",
            "beta_1y": "1.00%"
          }
        },
        {
          "symbol": "VTV",
          "symbolEn": "Vanguard Value Index Fund",
          "symbolZh": "价值股ETF-Vanguard",
          "symbolFan": "價值股ETF-Vanguard",
          "tick": [],
          "focus": "价值股",
          "fundSize": "1891.92",
          "returns": {
            "total_return": "336.99%",
            "10y": "158.17%",
            "5y": "59.25%",
            "3y": "53.16%",
            "1y": "24.50%"
          },
          "betas": {
            "beta_5y": "0.76%",
            "beta_3y": "0.73%",
            "beta_1y": "0.57%"
          }
        },
        {
          "symbol": "VUG",
          "symbolEn": "Vanguard Growth Index Fund",
          "symbolZh": "成长股ETF-Vanguard",
          "symbolFan": "成長股ETF-Vanguard",
          "tick": [],
          "focus": "大盘",
          "fundSize": "2279.34",
          "returns": {
            "total_return": "937.49%",
            "10y": "380.46%",
            "5y": "84.91%",
            "3y": "86.09%",
            "1y": "21.85%"
          },
          "betas": {
            "beta_5y": "1.23%",
            "beta_3y": "1.24%",
            "beta_1y": "1.30%"
          }
        },
        {
          "symbol": "VWO",
          "symbolEn": "Vanguard Emerging Markets Stock Index Fund",
          "symbolZh": "富时新兴市场ETF-Vanguard",
          "symbolFan": "富時新興市場ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "1235.73",
          "returns": {
            "total_return": "137.81%",
            "10y": "77.37%",
            "5y": "11.07%",
            "3y": "43.02%",
            "1y": "23.22%"
          },
          "betas": {
            "beta_5y": "0.62%",
            "beta_3y": "0.65%",
            "beta_1y": "1.05%"
          }
        },
        {
          "symbol": "VXF",
          "symbolEn": "Vanguard Extended Markets Index Fund",
          "symbolZh": "扩展市场ETF-Vanguard",
          "symbolFan": "擴展市場ETF-Vanguard",
          "tick": [],
          "focus": "拓展市场",
          "fundSize": "310.32",
          "returns": {
            "total_return": "669.43%",
            "10y": "179.00%",
            "5y": "29.14%",
            "3y": "61.57%",
            "1y": "27.24%"
          },
          "betas": {
            "beta_5y": "1.14%",
            "beta_3y": "1.27%",
            "beta_1y": "1.04%"
          }
        },
        {
          "symbol": "VYM",
          "symbolEn": "Vanguard High Dividend Yield Index Fund",
          "symbolZh": "高股利收益ETF-Vanguard",
          "symbolFan": "高股利收益ETF-Vanguard",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "795.98",
          "returns": {
            "total_return": "214.95%",
            "10y": "125.04%",
            "5y": "53.23%",
            "3y": "49.78%",
            "1y": "21.55%"
          },
          "betas": {
            "beta_5y": "0.74%",
            "beta_3y": "0.71%",
            "beta_1y": "0.63%"
          }
        },
        {
          "symbol": "XLB",
          "symbolEn": "Materials Select Sector SPDR",
          "symbolZh": "SPDR原物料类ETF",
          "symbolFan": "SPDR原物料類ETF",
          "tick": [],
          "focus": "材料",
          "fundSize": "83.79",
          "returns": {
            "total_return": "400.64%",
            "10y": "121.83%",
            "5y": "28.10%",
            "3y": "29.14%",
            "1y": "18.39%"
          },
          "betas": {
            "beta_5y": "0.93%",
            "beta_3y": "0.76%",
            "beta_1y": "0.66%"
          }
        },
        {
          "symbol": "XLE",
          "symbolEn": "Energy Select Sector SPDR Fund",
          "symbolZh": "能源指数ETF-SPDR",
          "symbolFan": "能源指數ETF-SPDR",
          "tick": [],
          "focus": "能源",
          "fundSize": "375.95",
          "returns": {
            "total_return": "369.02%",
            "10y": "63.44%",
            "5y": "106.85%",
            "3y": "36.91%",
            "1y": "23.45%"
          },
          "betas": {
            "beta_5y": "0.43%",
            "beta_3y": "0.03%",
            "beta_1y": "-0.65%"
          }
        },
        {
          "symbol": "XLF",
          "symbolEn": "Financial Select Sector SPDR Fund",
          "symbolZh": "金融行业ETF-SPDR",
          "symbolFan": "金融行業ETF-SPDR",
          "tick": [],
          "focus": "财务指标",
          "fundSize": "511.79",
          "returns": {
            "total_return": "183.67%",
            "10y": "193.80%",
            "5y": "51.74%",
            "3y": "61.89%",
            "1y": "7.52%"
          },
          "betas": {
            "beta_5y": "0.87%",
            "beta_3y": "0.83%",
            "beta_1y": "0.78%"
          }
        },
        {
          "symbol": "XLI",
          "symbolEn": "Industrial Select Sector SPDR Fund",
          "symbolZh": "工业指数ETF-SPDR",
          "symbolFan": "工業指數ETF-SPDR",
          "tick": [],
          "focus": "工业",
          "fundSize": "320.23",
          "returns": {
            "total_return": "673.50%",
            "10y": "223.20%",
            "5y": "80.09%",
            "3y": "70.57%",
            "1y": "25.51%"
          },
          "betas": {
            "beta_5y": "1.00%",
            "beta_3y": "1.01%",
            "beta_1y": "0.73%"
          }
        },
        {
          "symbol": "XLK",
          "symbolEn": "Technology Select Sector SPDR Fund",
          "symbolZh": "科技行业精选指数ETF-SPDR",
          "symbolFan": "科技行業精選指數ETF-SPDR",
          "tick": [],
          "focus": "信息技术",
          "fundSize": "1253.41",
          "returns": {
            "total_return": "1046.69%",
            "10y": "759.19%",
            "5y": "160.39%",
            "3y": "115.38%",
            "1y": "53.54%"
          },
          "betas": {
            "beta_5y": "1.34%",
            "beta_3y": "1.46%",
            "beta_1y": "1.52%"
          }
        },
        {
          "symbol": "XLP",
          "symbolEn": "Consumer Staples Select Sector SPDR",
          "symbolZh": "日常消费品精选行业指数ETF-SPDR",
          "symbolFan": "日常消費品精選行業指數ETF-SPDR",
          "tick": [],
          "focus": "必需消费品",
          "fundSize": "143.78",
          "returns": {
            "total_return": "223.40%",
            "10y": "56.09%",
            "5y": "20.30%",
            "3y": "14.64%",
            "1y": "3.32%"
          },
          "betas": {
            "beta_5y": "0.49%",
            "beta_3y": "0.43%",
            "beta_1y": "0.19%"
          }
        },
        {
          "symbol": "XLU",
          "symbolEn": "Utilities Select Sector SPDR Fund",
          "symbolZh": "公用事业精选行业指数ETF-SPDR",
          "symbolFan": "公用事業精選行業指數ETF-SPDR",
          "tick": [],
          "focus": "公用事业",
          "fundSize": "227.74",
          "returns": {
            "total_return": "193.95%",
            "10y": "76.71%",
            "5y": "35.90%",
            "3y": "33.94%",
            "1y": "9.91%"
          },
          "betas": {
            "beta_5y": "0.59%",
            "beta_3y": "0.41%",
            "beta_1y": "-0.01%"
          }
        },
        {
          "symbol": "XLV",
          "symbolEn": "Health Care Select Sector SPDR",
          "symbolZh": "医疗保健精选行业指数ETF-SPDR",
          "symbolFan": "醫療保健精選行業指數ETF-SPDR",
          "tick": [],
          "focus": "卫生保健",
          "fundSize": "390.90",
          "returns": {
            "total_return": "507.38%",
            "10y": "112.57%",
            "5y": "21.31%",
            "3y": "15.63%",
            "1y": "11.55%"
          },
          "betas": {
            "beta_5y": "0.58%",
            "beta_3y": "0.50%",
            "beta_1y": "0.43%"
          }
        },
        {
          "symbol": "XLY",
          "symbolEn": "Consumer Discretionary Select Sector SPDR Fund",
          "symbolZh": "非必需消费类ETF-SPDR",
          "symbolFan": "非必需消費類ETF-SPDR",
          "tick": [],
          "focus": "非必需消费品",
          "fundSize": "228.19",
          "returns": {
            "total_return": "812.50%",
            "10y": "195.56%",
            "5y": "34.45%",
            "3y": "42.39%",
            "1y": "8.53%"
          },
          "betas": {
            "beta_5y": "1.21%",
            "beta_3y": "1.20%",
            "beta_1y": "1.29%"
          }
        },
        {
          "symbol": "AAXJ",
          "symbolEn": "iShares MSCI All Country Asia",
          "symbolZh": "亚洲(除日本)ETF-iShares",
          "symbolFan": "亞洲(除日本)ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "40.27",
          "returns": {
            "total_return": "137.46%",
            "10y": "124.10%",
            "5y": "27.73%",
            "3y": "72.56%",
            "1y": "47.56%"
          },
          "betas": {
            "beta_5y": "0.72%",
            "beta_3y": "0.83%",
            "beta_1y": "1.33%"
          }
        },
        {
          "symbol": "ACWI",
          "symbolEn": "iShares MSCI ACWI ETF",
          "symbolZh": "iShares MSCI ACWI ETF",
          "symbolFan": "iShares MSCI ACWI ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "330.30",
          "returns": {
            "total_return": "211.00%",
            "10y": "177.84%",
            "5y": "56.70%",
            "3y": "62.24%",
            "1y": "24.76%"
          },
          "betas": {
            "beta_5y": "0.92%",
            "beta_3y": "0.89%",
            "beta_1y": "1.02%"
          }
        },
        {
          "symbol": "BND",
          "symbolEn": "Vanguard Total Bond Market Index Fund",
          "symbolZh": "总债券市场ETF-Vanguard",
          "symbolFan": "總債券市場ETF-Vanguard",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "1582.72",
          "returns": {
            "total_return": "-2.57%",
            "10y": "-12.63%",
            "5y": "-14.68%",
            "3y": "1.06%",
            "1y": "0.62%"
          },
          "betas": {
            "beta_5y": "0.25%",
            "beta_3y": "0.21%",
            "beta_1y": "0.10%"
          }
        },
        {
          "symbol": "BNDX",
          "symbolEn": "Vanguard Total International Bond ETF",
          "symbolZh": "总体国际债券ETF-Vanguard",
          "symbolFan": "總體國際債券ETF-Vanguard",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "823.36",
          "returns": {
            "total_return": "-4.53%",
            "10y": "-12.64%",
            "5y": "-15.39%",
            "3y": "-0.54%",
            "1y": "-2.03%"
          },
          "betas": {
            "beta_5y": "0.22%",
            "beta_3y": "0.18%",
            "beta_1y": "0.12%"
          }
        },
        {
          "symbol": "DVY",
          "symbolEn": "iShares Select Dividend ETF",
          "symbolZh": "股息指数ETF-iShares Dow Jones",
          "symbolFan": "股息指數ETF-iShares Dow Jones",
          "tick": [],
          "focus": "高股息率",
          "fundSize": "226.62",
          "returns": {
            "total_return": "202.86%",
            "10y": "83.61%",
            "5y": "32.77%",
            "3y": "34.55%",
            "1y": "17.85%"
          },
          "betas": {
            "beta_5y": "0.68%",
            "beta_3y": "0.62%",
            "beta_1y": "0.39%"
          }
        },
        {
          "symbol": "EMB",
          "symbolEn": "iShares JP Morgan USD Emerging Markets Bond ETF",
          "symbolZh": "新兴市场美元债ETF-iShares",
          "symbolFan": "新興市場美元債ETF-iShares",
          "tick": [],
          "focus": "广泛信用",
          "fundSize": "140.99",
          "returns": {
            "total_return": "-4.71%",
            "10y": "-14.14%",
            "5y": "-14.14%",
            "3y": "13.19%",
            "1y": "5.59%"
          },
          "betas": {
            "beta_5y": "0.51%",
            "beta_3y": "0.43%",
            "beta_1y": "0.31%"
          }
        },
        {
          "symbol": "IBB",
          "symbolEn": "iShares BIOTECHNOLOGY ETF",
          "symbolZh": "生物科技指数ETF-iShares",
          "symbolFan": "生物科技指數ETF-iShares",
          "tick": [],
          "focus": "卫生保健",
          "fundSize": "81.75",
          "returns": {
            "total_return": "418.25%",
            "10y": "98.60%",
            "5y": "9.92%",
            "3y": "32.13%",
            "1y": "36.50%"
          },
          "betas": {
            "beta_5y": "0.73%",
            "beta_3y": "0.68%",
            "beta_1y": "0.77%"
          }
        },
        {
          "symbol": "ICLN",
          "symbolEn": "iShares Global Clean Energy ETF",
          "symbolZh": "环球清洁能源ETF-iShares",
          "symbolFan": "環球清潔能源ETF-iShares",
          "tick": [],
          "focus": "主题",
          "fundSize": "30.56",
          "returns": {
            "total_return": "-60.80%",
            "10y": "141.22%",
            "5y": "-9.10%",
            "3y": "9.12%",
            "1y": "60.63%"
          },
          "betas": {
            "beta_5y": "1.07%",
            "beta_3y": "1.07%",
            "beta_1y": "1.12%"
          }
        },
        {
          "symbol": "IEI",
          "symbolEn": "iShares 3-7 Year Treasury Bond ETF",
          "symbolZh": "美国国债3-7年ETF-iShares",
          "symbolFan": "美國國債3-7年ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "183.72",
          "returns": {
            "total_return": "16.90%",
            "10y": "-7.78%",
            "5y": "-10.26%",
            "3y": "1.05%",
            "1y": "-0.75%"
          },
          "betas": {
            "beta_5y": "0.14%",
            "beta_3y": "0.09%",
            "beta_1y": "0.06%"
          }
        },
        {
          "symbol": "INDY",
          "symbolEn": "iShares India 50 ETF",
          "symbolZh": "iShares安硕印度50 ETF",
          "symbolFan": "iShares安碩印度50 ETF",
          "tick": [],
          "focus": "总市场",
          "fundSize": "5.56",
          "returns": {
            "total_return": "72.67%",
            "10y": "53.83%",
            "5y": "-7.14%",
            "3y": "-1.38%",
            "1y": "-18.60%"
          },
          "betas": {
            "beta_5y": "0.45%",
            "beta_3y": "0.41%",
            "beta_1y": "0.72%"
          }
        },
        {
          "symbol": "IUSG",
          "symbolEn": "iShares Core S&P US Growth ETF",
          "symbolZh": "核心标普美国增长ETF-iShares",
          "symbolFan": "核心標普美國增長ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "322.61",
          "returns": {
            "total_return": "476.62%",
            "10y": "355.80%",
            "5y": "89.62%",
            "3y": "92.22%",
            "1y": "28.39%"
          },
          "betas": {
            "beta_5y": "1.17%",
            "beta_3y": "1.18%",
            "beta_1y": "1.26%"
          }
        },
        {
          "symbol": "IUSV",
          "symbolEn": "iShares Core S&P US Value ETF",
          "symbolZh": "核心美国价值ETF-iShares",
          "symbolFan": "核心美國價值ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "264.08",
          "returns": {
            "total_return": "357.75%",
            "10y": "147.37%",
            "5y": "55.08%",
            "3y": "40.74%",
            "1y": "18.35%"
          },
          "betas": {
            "beta_5y": "0.84%",
            "beta_3y": "0.83%",
            "beta_1y": "0.69%"
          }
        },
        {
          "symbol": "MCHI",
          "symbolEn": "iShares MSCI China ETF",
          "symbolZh": "MSCI中国ETF-iShares",
          "symbolFan": "MSCI中國ETF-iShares",
          "tick": [],
          "focus": "总市场",
          "fundSize": "63.35",
          "returns": {
            "total_return": "2.53%",
            "10y": "29.62%",
            "5y": "-34.06%",
            "3y": "11.86%",
            "1y": "-3.25%"
          },
          "betas": {
            "beta_5y": "0.33%",
            "beta_3y": "0.36%",
            "beta_1y": "0.99%"
          }
        },
        {
          "symbol": "PFF",
          "symbolEn": "iShares Preferred and Income Securities ETF",
          "symbolZh": "iShares优先股和收益证券ETF",
          "symbolFan": "iShares優先股和收益證券ETF",
          "tick": [],
          "focus": "广泛信用",
          "fundSize": "135.55",
          "returns": {
            "total_return": "-38.01%",
            "10y": "-20.99%",
            "5y": "-20.24%",
            "3y": "1.77%",
            "1y": "2.81%"
          },
          "betas": {
            "beta_5y": "0.53%",
            "beta_3y": "0.51%",
            "beta_1y": "0.40%"
          }
        },
        {
          "symbol": "QQQ",
          "symbolEn": "Invesco QQQ Trust Series 1",
          "symbolZh": "纳指100ETF-Invesco QQQ Trust",
          "symbolFan": "納指100ETF-Invesco QQQ Trust",
          "tick": [],
          "focus": "大盘",
          "fundSize": "4953.26",
          "returns": {
            "total_return": "1313.22%",
            "10y": "571.91%",
            "5y": "110.26%",
            "3y": "98.43%",
            "1y": "35.88%"
          },
          "betas": {
            "beta_5y": "1.23%",
            "beta_3y": "1.23%",
            "beta_1y": "1.31%"
          }
        },
        {
          "symbol": "SHV",
          "symbolEn": "iShares Barclays Short Treasury Bond Fund",
          "symbolZh": "美国短期国债ETF-iShares",
          "symbolFan": "美國短期國債ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "207.48",
          "returns": {
            "total_return": "1.38%",
            "10y": "-0.20%",
            "5y": "-0.27%",
            "3y": "-0.03%",
            "1y": "-0.04%"
          },
          "betas": {
            "beta_5y": "0.01%",
            "beta_3y": "0.00%",
            "beta_1y": "0.01%"
          }
        },
        {
          "symbol": "SHY",
          "symbolEn": "iShares 1-3 Year Treasury Bond ETF",
          "symbolZh": "美国国债1-3年ETF-iShares",
          "symbolFan": "美國國債1-3年ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "254.15",
          "returns": {
            "total_return": "0.74%",
            "10y": "-3.83%",
            "5y": "-4.92%",
            "3y": "0.89%",
            "1y": "-0.67%"
          },
          "betas": {
            "beta_5y": "0.05%",
            "beta_3y": "0.02%",
            "beta_1y": "0.03%"
          }
        },
        {
          "symbol": "SKYY",
          "symbolEn": "First Trust ISE Cloud Computing Index Fund",
          "symbolZh": "First Trust ISE云计算指数基金",
          "symbolFan": "First Trust ISE雲計算指數基金",
          "tick": [],
          "focus": "信息技术",
          "fundSize": "29.39",
          "returns": {
            "total_return": "553.07%",
            "10y": "332.52%",
            "5y": "26.70%",
            "3y": "75.26%",
            "1y": "13.26%"
          },
          "betas": {
            "beta_5y": "1.24%",
            "beta_3y": "1.39%",
            "beta_1y": "1.26%"
          }
        },
        {
          "symbol": "SMH",
          "symbolEn": "VanEck Semiconductor ETF",
          "symbolZh": "半导体指数ETF-VanEck",
          "symbolFan": "半導體指數ETF-VanEck",
          "tick": [],
          "focus": "信息技术",
          "fundSize": "756.77",
          "returns": {
            "total_return": "1256.46%",
            "10y": "2111.88%",
            "5y": "396.77%",
            "3y": "302.14%",
            "1y": "137.76%"
          },
          "betas": {
            "beta_5y": "1.73%",
            "beta_3y": "1.93%",
            "beta_1y": "1.77%"
          }
        },
        {
          "symbol": "SOXX",
          "symbolEn": "iShares Semiconductor ETF",
          "symbolZh": "半导体ETF-iShares",
          "symbolFan": "半導體ETF-iShares",
          "tick": [],
          "focus": "信息技术",
          "fundSize": "456.25",
          "returns": {
            "total_return": "2388.51%",
            "10y": "1808.75%",
            "5y": "312.92%",
            "3y": "254.56%",
            "1y": "164.84%"
          },
          "betas": {
            "beta_5y": "1.80%",
            "beta_3y": "2.14%",
            "beta_1y": "1.91%"
          }
        },
        {
          "symbol": "TLT",
          "symbolEn": "iShares 20+ Year Treasury Bond ETF",
          "symbolZh": "20+年以上美国国债ETF-iShares",
          "symbolFan": "20+年以上美國國債ETF-iShares",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "407.14",
          "returns": {
            "total_return": "4.43%",
            "10y": "-36.62%",
            "5y": "-40.16%",
            "3y": "-15.89%",
            "1y": "0.38%"
          },
          "betas": {
            "beta_5y": "0.52%",
            "beta_3y": "0.55%",
            "beta_1y": "0.15%"
          }
        },
        {
          "symbol": "TQQQ",
          "symbolEn": "ProShares UltraPro QQQ ETF",
          "symbolZh": "三倍做多纳指ETF-ProShares",
          "symbolFan": "三倍做多納指ETF-ProShares",
          "tick": [],
          "focus": "大盘",
          "fundSize": "404.18",
          "returns": {
            "total_return": "38014.90%",
            "10y": "3719.32%",
            "5y": "178.40%",
            "3y": "292.26%",
            "1y": "107.66%"
          },
          "betas": {
            "beta_5y": "3.71%",
            "beta_3y": "3.93%",
            "beta_1y": "3.99%"
          }
        },
        {
          "symbol": "VCIT",
          "symbolEn": "Vanguard Intermediate-Term Corporate Bond ETF",
          "symbolZh": "中期公司债券ETF-Vanguard",
          "symbolFan": "中期公司債券ETF-Vanguard",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "668.45",
          "returns": {
            "total_return": "9.57%",
            "10y": "-7.01%",
            "5y": "-13.17%",
            "3y": "4.93%",
            "1y": "0.70%"
          },
          "betas": {
            "beta_5y": "0.33%",
            "beta_3y": "0.27%",
            "beta_1y": "0.17%"
          }
        },
        {
          "symbol": "VCSH",
          "symbolEn": "Vanguard Short-Term Corporate Bond Idx Fd",
          "symbolZh": "短期公司债券ETF-Vanguard",
          "symbolFan": "短期公司債券ETF-Vanguard",
          "tick": [],
          "focus": "投资等级",
          "fundSize": "447.72",
          "returns": {
            "total_return": "4.71%",
            "10y": "-2.25%",
            "5y": "-4.70%",
            "3y": "4.58%",
            "1y": "-0.18%"
          },
          "betas": {
            "beta_5y": "0.12%",
            "beta_3y": "0.09%",
            "beta_1y": "0.08%"
          }
        },
        {
          "symbol": "VXUS",
          "symbolEn": "Vanguard Total International Stock Index Fund",
          "symbolZh": "全世界股票ETF-Vanguard",
          "symbolFan": "全世界股票ETF-Vanguard",
          "tick": [],
          "focus": "总市场",
          "fundSize": "1556.05",
          "returns": {
            "total_return": "72.06%",
            "10y": "96.78%",
            "5y": "31.23%",
            "3y": "50.15%",
            "1y": "26.51%"
          },
          "betas": {
            "beta_5y": "0.78%",
            "beta_3y": "0.70%",
            "beta_1y": "1.04%"
          }
        }
      ]
        },
        {
          tabName: "Crypto",
          datas: [
            { symbol: "BTCUSD", tick: [], symbolZh: '比特币', },

          ],
        },
      ],
      tabIndex: 0,
      dataIndex: 0,
      showMore: false,
      innerTableFn: "",
      popupControl: false,
      innerTickIndex: -1,
      targetNavigationIndex: 1,
      isMoible: false,
      lastClickTime: 0,
      newTypeTable: '',
      currentReturnKey: 'total_return',
      showReturnDropdown: false,
      currentBetaKey: 'beta_5y',
      showBetaDropdown: false,
      showBetaTooltip: false,
      returnTextMap: {
        'total_return': '历史总收益率',
        '10y': '过去 10 年',
        '5y': '过去 5 年',
        '3y': '过去 3 年',
        '1y': '过去 1 年'
      },
      betaTextMap: {
        'beta_5y': '过去 5 年 β',
        'beta_3y': '过去 3 年 β',
        'beta_1y': '过去 1 年 β'
      }
    };
  },
  computed: {
    showData() {
      return this.tableData[this.tabIndex == 1 ? 2 : this.tabIndex == 2 ? 1 : this.tabIndex].datas.filter((item) => {
        return item.tick && item.tick.length;
      });
    },
    innerTickList() {
      const item = this.showData[this.innerTickIndex];
      return (item && item.tick) || [];
    },
    pageNavigationNumber() {
      return Math.ceil(this.showData.length / 6);
    },
    visiblePages() {
      const total = this.pageNavigationNumber;
      const c = this.targetNavigationIndex;
      if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
      if (c <= 3) return [1, 2, 3, '+1', total]; // 0 代表 …
      if (c >= total - 2) return [1, '-1', total - 2, total - 1, total];
      return [1, '-1', c - 1, c, c + 1, '+1', total]; // 7 项
    },
  },
  created() {
    this.tableData.forEach((item, index) => {
      item.datas.forEach((data) => {
        data.rule = this.rulesData(
          data.symbol,
          index == 1 ? 2 : index == 2 ? 1 : index
        );
      });
    });
    this.newTypeTable = ['/service', '/technology'].some(i => location.href.includes(i))
    this.getListData();
    let time = new Date().getMilliseconds();
    this.$http("/ebc/api/getToken/run", {
      date: time,
      CheckSum: md5(time + "YISENCE"),
    }).then((res) => {
      let url = "wss://pricecloud.eappservice.com/ws?token=" + res.data.data;
      this.createWebSocket(url);
    });
    // ;
  },
  mounted() {
    const pageOverlay = document.getElementById("pageOverLay");
    let that = this;
    this.mountPopover()
    !this.newTypeTable && this.setPopover();
    let timer;
    window.addEventListener("resize", () => {
      clearTimeout(timer);
      timer = setTimeout(() => that.checkMobile(), 200);
    });
    that.checkMobile()
    window.ProductVM = this;
    document.dispatchEvent(myEvent);
  },
  methods: {
    toPctNumber(value) {
      if (value == null) return null;
      const raw = String(value).trim();
      if (!raw) return null;
      const num = parseFloat(raw.replace(/[%\s]/g, '').replace(/^\+/, ''));
      return Number.isFinite(num) ? num : null;
    },
    sortEtfByReturn(key) {
      const etfTab = this.tableData.find((t) => t && t.tabName === "ETF CFDs");
      if (!etfTab || !Array.isArray(etfTab.datas)) return;

      etfTab.datas.sort((a, b) => {
        const av = this.toPctNumber(a && a.returns ? a.returns[key] : null);
        const bv = this.toPctNumber(b && b.returns ? b.returns[key] : null);
        if (av == null && bv == null) return 0;
        if (av == null) return 1;
        if (bv == null) return -1;
        return bv - av;
      });
    },
    selectReturn(key) {
      this.currentReturnKey = key;
      this.sortEtfByReturn(key);
      this.showReturnDropdown = false;
    },
    selectBeta(key) {
      this.currentBetaKey = key;
      this.showBetaDropdown = false;
    },
    initETFTable() {
      this.tableData.forEach(tab => {
        if (tab.tabName === "ETF CFDs") {
          tab.datas.forEach(item => {
            item.fundSize = item.fundSize.replace('亿美元', '');
          });
        }
      });


      // 2. 提取文本的核心函数
      const extractI18nText = () => {
        // 提取收益率文本 (第6列 1-5项)
        const returnItems = document.querySelectorAll('.product-table-th.etf-layout .product-table-td:nth-child(6) .etf-dropdown-item');
        if (returnItems && returnItems.length >= 5) {
          this.returnTextMap['total_return'] = returnItems[0].innerHTML.trim();
          this.returnTextMap['10y'] = returnItems[1].innerHTML.trim();
          this.returnTextMap['5y'] = returnItems[2].innerHTML.trim();
          this.returnTextMap['3y'] = returnItems[3].innerHTML.trim();
          this.returnTextMap['1y'] = returnItems[4].innerHTML.trim();
        }

        // 提取 Beta 文本 
        // 【注意】根据你前面发我的 HTML 结构，Beta 列实际上是第 7 列 (nth-child(7))。
        // 如果你确实改为了第 3 列，请将下面的 nth-child(7) 改为 nth-child(3)
        const betaItems = document.querySelectorAll('.product-table-th.etf-layout .product-table-td:nth-child(7) .etf-dropdown-item');
        if (betaItems && betaItems.length >= 3) {
          this.betaTextMap['beta_5y'] = betaItems[0].innerHTML.trim();
          this.betaTextMap['beta_3y'] = betaItems[1].innerHTML.trim();
          this.betaTextMap['beta_1y'] = betaItems[2].innerHTML.trim();
        }
      };
      this.sortEtfByReturn(this.currentReturnKey);
    },
    mountPopover() {
      const div = document.createElement("div");
      div.className = "popover body-14_regular ";
      div.id = "p1";
      div.innerHTML =
        "订单中的流动性报价层级，展现了市场中最优订单数量，其中第一层是头层报价，提供真正机构原始点差。";

      // 插到 body
      document.body.appendChild(div);
    },
    rulesData(symbol, tabIndex) {
      console.log()
      if (tabIndex == 0) {
        return "500:1";
      } else if (tabIndex == 1) {
        const normalRules = {
          XAUUSD: "500:1",
          XAGUSD: "500:1",
          XBRUSD: "100:1",
          XTIUSD: "50:1",
          XNGUSD: "100:1",
        };
        return normalRules[symbol];
      } else if (tabIndex == 2) {
        return "100:1";
      } else if (tabIndex == 5) {
        return "200:1 <span> *</span>";
      } else {
        return "5:1";
      }
    },
    syncFakeScroll(wrapperSel, scrollSel) {
      const wrap = document.querySelector(wrapperSel);
      const scroll = wrap.querySelector(scrollSel || ".product-box");
      const track = wrap.querySelector(".fake-scrollbar");
      const thumb = wrap.querySelector(".fake-thumb");
      function sync() {
        const w = scroll.clientWidth;
        const sw = scroll.scrollWidth;
        const l = scroll.scrollLeft;
        const maxL = sw - w;
        if (maxL <= 0) {
          thumb.style.width = "0px";
          track.style.display = "none";
          wrap.classList.add("noScroll");
          return;
        }

        const thumbW = (w / sw) * track.clientWidth;
        thumb.style.width = thumbW + "px";
        const maxMove = track.clientWidth - thumbW;
        if (l <= 0) {
          wrap.classList.add("noScroll");
        } else {
          wrap.classList.remove("noScroll");
        }
        thumb.style.transform = `translateX(${(l / maxL) * maxMove}px)`;
      }

      scroll.addEventListener("scroll", sync, { passive: true });
      scroll.addEventListener("resize", sync);
      sync();
      return sync;
    },
    lock() {
      if (this.newTypeTable && !this.isMoible) return
      const pageOverlay = document.getElementById("pageOverLay");

      document.documentElement.classList.add("no-scroll");
      pageOverlay.style.display = "block";
      setTimeout(() => {
        pageOverlay.style.opacity = 1;
      }, 100);
    },
    unlock() {
      const pageOverlay = document.getElementById("pageOverLay");

      pageOverlay.style.opacity = 0;
      setTimeout(() => {
        pageOverlay.style.display = "none";
        document.documentElement.classList.remove("no-scroll");
      }, 700);
    },
    getImage(name) {
      try {
        return require(`@/assets/image/productLogo/${name}.png`);
      } catch (e) {
      }
    },
    showFormPopup(data) {
      if ((Date.now() - this.lastClickTime) < 500) return;
      this.lastClickTime = Date.now();
      if (this.newTypeTable && this.innerTickIndex === data) {
        this.innerTickIndex = -1
      } else {
        this.innerTickIndex = data;
      }
      this.popupControl = true;
      this.lock();
      setTimeout(() => {
        this.innerTableFn && this.innerTableFn();
        this.newTypeTable && this.innerTickIndex != -1 && this.setPopover()

      });
    },
    closePopup() {
      this.popupControl = false;
      this.unlock();
    },
    setPopover() {
      const po = document.getElementById("p1");
      const popover = document.querySelector('[data-popover="p1"]');
      console.log(popover)
      let ifShow = false;
      function place() {
        const r = popover.getBoundingClientRect();
        if (window.matchMedia("(max-width:996px)").matches) {
          po.style.left = r.left + 18 + "px";
          po.style.top = r.bottom - po.offsetHeight / 2 - 20 + "px";
          return;
        }

        po.style.left = r.left - 20 + "px";
        po.style.top = r.bottom - 5 + "px";
      }
      function show() {
        if (ifShow) return;
        ifShow = true;
        place();
        po.classList.add("show");
      }
      function hide() {
        if (!ifShow) return;
        ifShow = false;
        po.classList.remove("show");
      }
      if (window.matchMedia("(max-width:996px)").matches) {
        popover.addEventListener("click", (e) => {
          e.stopPropagation();
          show();
        });
        document.addEventListener("click", () => {
          if (ifShow) hide();
        });
        return;
      }
      popover.addEventListener("mouseenter", show);
      popover.addEventListener("mouseleave", hide);
      po.addEventListener("mouseenter", show);
      po.addEventListener("mouseleave", hide);
    },
    setTargetNavigationIndex(index) {
      if (index === '+1') {
        this.targetNavigationIndex += 1
      } else if (index === '-1') {
        this.targetNavigationIndex -= 1
      } else {
        this.targetNavigationIndex = index
      }
    },
    checkMobile() {
      const mobile = window.innerWidth < 996;
      if (mobile !== this.isMobile) {
        this.isMoible = mobile;
      }
    },

    changeInnerTable(index) {
      if (this.dataIndex == index) {
        this.dataIndex = -1;
      } else {
        this.dataIndex = index;
      }
    },
    changeHandle(index) {
      this.dataIndex = 0;
      this.innerTickIndex = -1;
      this.tabIndex = index;
      this.targetNavigationIndex = 1;
      this.showMore = false;
      index == 4 && (this.initETFTable())
    },
    // 传入ask,bid,返回点差Spread
    getSpread(t, e) {
      var o = /^\+?[1-9][0-9]*$/,
        r = 0,
        d = 0,
        c = 0;
      return (
        o.test(t) || (d = t.toString().split(".")[1].length),
        o.test(e) || (c = e.toString().split(".")[1].length),
        d > c
          ? 1 === d
            ? (r = 10 * t - 10 * e)
            : 2 === d
              ? (r = 100 * t - 100 * e)
              : 3 === d
                ? (r = 1e3 * t - 1e3 * e)
                : 4 === d
                  ? (r = 1e4 * t - 1e4 * e)
                  : 5 === d && (r = 1e5 * t - 1e5 * e)
          : 1 === c
            ? (r = 10 * t - 10 * e)
            : 2 === c
              ? (r = 100 * t - 100 * e)
              : 3 === c
                ? (r = 1e3 * t - 1e3 * e)
                : 4 === c
                  ? (r = 1e4 * t - 1e4 * e)
                  : 5 === c && (r = 1e5 * t - 1e5 * e),
        r.toFixed(0)
      );
    },
    // 比较大小返回对应类名
    compareValues(value1, value2, className = "") {
      // 尝试将两个值转换为数字
      const num1 = Number(value1);
      const num2 = Number(value2);

      // 检查转换后的值是否都是有效的数字
      if (!isNaN(num1) && !isNaN(num2)) {
        if (num1 >= num2) {
          return "product-green";
        } else if (num1 < num2) {
          return "product-red";
        } else {
          // 两者相等的情况
          return className;
        }
      }

      // 如果转换后不是有效数字，则返回空字符串
      return "";
    },
    updateTick(symbolToUpdate, newTickValue) {
      if (!newTickValue || !newTickValue.length) return
      newTickValue = newTickValue.map((el) => {
        return {
          ...el,
          spread: this.getSpread(el.ask_price, el.bid_price),
        };
      });
      // 遍历tableData中的每个tab
      this.tableData.some((tab) => {
        // 查找datas数组中匹配symbol的项
        const itemIndex = tab.datas.findIndex(
          (item) => item.symbol === symbolToUpdate
        );

        if (itemIndex !== -1) {
          // 如果找到了匹配的项
          // 使用Vue.set确保响应式更新
          // console.log("tab", tab.datas, itemIndex, newTickValue);
          newTickValue = newTickValue.map((tickItem, index) => {
            let t = {
              askClassName: this.compareValues(tickItem.ask_price),
              bidClassName: this.compareValues(tickItem.bid_price),
              ...tickItem,
            };
            if (tab.datas[itemIndex].tick[index]) {
              t = {
                askClassName: this.compareValues(
                  tickItem.ask_price,
                  tab.datas[itemIndex].tick[index].ask_price,
                  tab.datas[itemIndex].tick[index].askClassName
                ),
                bidClassName: this.compareValues(
                  tickItem.bid_price,
                  tab.datas[itemIndex].tick[index].ask_price,
                  tab.datas[itemIndex].tick[index].bidClassName
                ),
                ...tickItem,
              };
            }

            return t;
          });
          this.$set(tab.datas, itemIndex, {
            ...tab.datas[itemIndex], // 保留原有数据
            tick: newTickValue, // 更新tick值
          });
          return true; // 找到后退出some循环
        }
      });
    },
    createWebSocket(url) {
      let _this = this;
      var ws = new WebSocket(url);

      ws.onopen = function () {
        ws.send("连接成功");
      };
      let f = true;
      ws.onmessage = function (event) {
        try {
          var data = JSON.parse(event.data);
        } catch (e) {
          return false;
        }
        _this.updateTick(data.symbol, data.tick);
      };

      ws.onerror = function (event) { };

      ws.onclose = function () { };
    },
    // 获取历史数据列表
    getListData() {
      fetch("https://www.ebccfd.com/portal/api/getSymbolAll", {
        method: "get",
      })
        .then((response) => {
          // 检查请求是否成功
          if (!response.ok) {
            throw new Error(
              "Network response was not ok " + response.statusText
            );
          }
          // 将 Response 对象转换为 JSON 对象
          return response.json();
        })
        .then((response) => {
          let data = response.rows;
          console.log("getSymbolAll data", data);
          data.map((item) => {
            let t = {
              symbol: item.displaySymbol,
              time: new Date(item.updateTime).getTime(),
              tick: [
                {
                  ask_price: item.ask,
                  ask_size: "",
                  bid_price: item.bid,
                  bid_size: "",
                  spread: this.getSpread(item.ask, item.bid),
                },
              ],
            };
            this.updateTick(t.symbol, t.tick);
          });
          let that = this
          setTimeout(() => {
            that.syncFakeScroll('.productModuleContainer');
            if ((this.newTypeTable && this.isMoible) || !this.newTypeTable) {
              that.innerTableFn = that.syncFakeScroll('.innerTableContainer', '.product-table')
            }
            this.newTypeTable && !window.matchMedia('(max-width: 996px)').matches && this.showFormPopup(0)
          })
        })
        .catch((err) => { });
    },
  },
};
</script>

<style lang="scss">
.no-scroll {
  overflow: hidden;
}

.popover {
  --shadow: rgba(0, 0, 0, 0.6);
  --arrow-shadow: rgba(0, 0, 0, 0.5);
}

.popover {
  position: fixed;
  margin-top: 8px;
  padding: 8px 12px;
  color: var(--ebc-text-primary_white);
  background: var(--ebc-neutral-bg_d);
  border-radius: var(--ebc-corner-radius-rc04);
  box-shadow: 0 2px 8px var(--shadow);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
  max-width: 500rem;
  z-index: 99999999;
  text-align: left;
  font-size: 14rem;
  line-height: 22rem;
}

.popover.show {
  opacity: 1;
  visibility: visible;
}

/* 阴影三角 + 本体三角 */
.popover::before,
.popover::after {
  content: "";
  position: absolute;
  left: 28px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid var(--ebc-neutral-bg_d);
}

.ar.popover::before,
.ar.popover::after {
  left: unset;
  right: 28px;
}

.popover::before {
  top: -7px;
}

.popover::after {
  top: -6px;
}

.formPopup {
  border-radius: var(--ebc-corner-radius-rc24);
  background: var(--ebc-basecolor-white-100);
  box-shadow: 20px 40px 60px 0 rgba(0, 0, 0, 0.1);
  width: 1000rem;
  /* height: fit-content; */
  padding: 32rem;
  position: fixed;
  z-index: -1;
  left: 50%;
  top: 240rem;
  transform: translate(-50%, 0) scale(0.1);
  opacity: 0;
  transition: bottom 0.3s ease-in-out, opacity 0.3s ease-in-out,
    transform 0.3s ease-in-out;
  transform-origin: center;
}

.formPopup svg {
  cursor: pointer;
}

@media (max-height: 850px) and (min-width: 996px) {
  .formPopup {
    top: 160rem;
  }
}

.formPopup svg {
  position: absolute;
  top: 24rem;
  right: 24rem;
  width: 32rem;
  height: 32rem;
}

.ar .formPopup svg {
  right: unset;
  left: 24rem;
}

.formPopup h3 {
  margin: 16rem 0 32rem;
}

.showFormPopup {
  z-index: 999999;
  opacity: 1;
  transform: translate(-50%, 0%) scale(1);
}

#productModule {
  margin-top: 60rem;
}

#productModule .product-box {
  width: 1200rem;
  margin: 0 auto;
}

@media (min-width: 996px) {
  .newTypeInnerTable {
    padding-inline: 32rem;
  }

  .newTypeTable .product-innertable-tbody {
    height: fit-content !important;
  }

  #productModule .newTypeTable .product-table-tr {
    border-bottom: 0;
  }

  .newTypeTableChooseRow .product-innertable,
  .newTypeTableChooseRow .product-innertable-tr,
  .newTypeTableChooseRow .newTypeInnerTable,
  .newTypeTableChooseRow .product-table-tr {
    background: var(--ebc-neutral-bg_b) !important;
  }

  .newTypeTable .product-table-th .product-table-td:nth-child(2),
  .newTypeTable .product-table-th .product-table-td:nth-child(3),
  .newTypeTable .product-table-tr .product-table-td:nth-child(2),
  .newTypeTable .product-table-tr .product-table-td:nth-child(3) {
    text-align: right !important;
    justify-content: flex-end !important;
  }

  .newTypeTable .product-table-th .product-table-td:nth-child(6),
  .newTypeTable .product-table-tr .product-table-td:nth-child(6) {
    text-align: right !important;
    justify-content: flex-end !important;
    padding-right: 32rem !important;
  }

  .newTypeTable .rotate90 {
    transform: rotate(0deg) !important;
  }

  .newTypeTable .newTypeTableChooseRow .rotate90 {
    transform: rotate(180deg) !important;
  }

  #productModule .product-box .product-table {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    background: var(--Neutral-BG_A, #FFF);
    overflow: hidden;
  }

  #productModule .product-box .product-table.newTypeTable {
    border: 2px solid rgba(0, 0, 0, 0.12);
    border-radius: var(--ebc-corner-radius-rc16);
    overflow: hidden;
  }

  #productModule .innerTableContainer .product-table {
    border: 0;
    overflow: unset
  }
}

#productModule .iBtn {
  border: 0;
  margin: 20rem auto;
}

#productModule .product-table-th {
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

#productModule .newTypeTable .product-table-th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

@media (min-width: 996px) {
  #productModule .newTypeTable .product-table-th {
    background: var(--ebc-neutral-bg_c);
    border-top-left-radius: var(--ebc-corner-radius-rc16);
    border-top-right-radius: var(--ebc-corner-radius-rc16);
  }

  #productModule .product-box {
    width: 1200rem;
    margin-inline: auto;
  }
}

#productModule .product-table-th .product-table-td {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1.5;
  color: var(--ebc-text-primary);
  padding: 27rem 0;
}

#productModule.jp .product-table-tr .product-table-td,
#productModule.jp .product-table-th .product-table-td {
  flex: 2;
}

#productModule .product-table-th .product-table-td:first-child {
  flex: 4;
  justify-content: flex-start;
  padding-left: 32rem;
}

#productModule.ar .product-table-tr .product-table-td:first-child,
#productModule.ar .product-table-th .product-table-td:first-child {
  padding-right: 24rem;
}

#productModule .product-table-th .product-table-td:nth-child(2),
#productModule .product-table-th .product-table-td:nth-child(3),
#productModule .product-table-th .product-table-td:nth-child(6) {
  flex: 2;
}

#productModule .product-table-tr {
  display: flex;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

#productModule .product-table-tr:hover,
#productModule .product-table-tr:hover .product-table-td:first-child {
  background: var(--ebc-neutral-bg_b);
}

#productModule .product-table-tr .product-table-td {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 2;
  color: var(--ebc-text-primary);
  line-height: 1em;
  padding: 32rem 0;
}

#productModule .product-table-tr .product-table-td {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1.5;
  color: var(--ebc-text-primary);
  line-height: 1em;
  padding-block: 24rem;
}

#productModule .newTypeTable .product-table-tr .product-table-td {
  padding: 32rem 0;
}

.product-table-td .productPageTable {
  gap: 16rem;
  line-height: 26rem;
}

.product-table-td .productPageTable img {
  width: 40rem;
  height: 40rem;
}

.product-table-td .productPageTable .secondTitle {
  color: var(--ebc-text-secondary);
  margin-top: 2rem;
}

@media (max-width: 996px) {
  .product-table-td .productPageTable {
    gap: 24rem;
    line-height: 48rem;
  }

  .product-table-td .productPageTable img {
    width: 56rem;
    height: 56rem;
  }
}

#productModule .product-table-tr .product-table-td:nth-child(2),
#productModule .product-table-tr .product-table-td:nth-child(3),
#productModule .product-table-th .product-table-td:nth-child(2),
#productModule .product-table-th .product-table-td:nth-child(3) {
  text-align: left;
  justify-content: flex-start;
}

#productModule .product-table-tr .product-table-td:first-child {
  flex: 4;
  justify-content: flex-start;
  padding-left: 32rem;
  text-align: left;
}

#productModule.es .product-table-tr .product-table-td:first-child,
#productModule.es .product-table-th .product-table-td:first-child {
  flex: 3;
}

#productModule.pt .product-table-tr .product-table-td:nth-child(5),
#productModule.pt .product-table-th .product-table-td:nth-child(5),
#productModule.es .product-table-tr .product-table-td:nth-child(5),
#productModule.es .product-table-th .product-table-td:nth-child(5) {
  flex: 2;
}

#productModule .product-table-tr .product-table-td:nth-child(2),
#productModule .product-table-tr .product-table-td:nth-child(3),
#productModule .product-table-tr .product-table-td:nth-child(6) {
  flex: 2;
}

/* #productModule .grow-product-table .product-table-tr .product-table-td {
    width: 23.99%;
  } */

#productModule .rotate90 {
  transform: rotate(-90deg);
  margin-left: 4rem;
}

#productModule .rotate180 {
  transform: rotate(180deg);
}

#productModule .product-innertable {
  background-color: #fff;
}

#productModule .product-innertable-th {
  display: flex;
  height: 64rem;
  color: var(--ebc-text-secondary);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-right: 12rem;
}

#productModule.ar .product-innertable-tbody,
#productModule.ar .product-innertable-tr,
#productModule.ar .product-innertable-th {
  padding-right: 0;
  padding-left: 12rem;
}

#productModule .product-innertable-th .product-innertable-td:first-child {
  justify-content: flex-start;
  flex: 0.6;
}

#productModule .product-innertable-th .product-innertable-td {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
}

#productModule .product-innertable-th .product-innertable-td .iconfont {
  margin-left: 4rem;
}

#productModule.ar .product-innertable-th .product-innertable-td .iconfont {
  margin-right: 4rem;
  margin-left: unset;
}

/* #productModule
    .grow-product-table
    .product-innertable-th
    .product-innertable-td {
    width: 23.99%;
  } */
#productModule .product-innertable-tbody {
  height: 320rem;
  overflow-y: auto;
  padding-right: 12rem;
}

#productModule .product-innertable-tr {
  display: flex;
  height: 64rem;
  background: #fff;
}

#productModule .product-innertable-tr .product-innertable-td:nth-child(1) {
  flex: 0.6;
  justify-content: flex-start;
}

#productModule .product-innertable-tr .product-innertable-td {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  color: var(--ebc-text-primary);
}

/* #productModule
    .grow-product-table
    .product-innertable-tr
    .product-innertable-td {
    width: 23.99%;
  } */

#productModule .product-red {
  color: #cd2626 !important;
}

#productModule .product-green {
  color: #0eb565 !important;
}

@media (max-width: 996px) {

  #productModule .product-table-tr:hover,
  #productModule .product-table-tr:hover .product-table-td:first-child {
    background: #fff;
  }

  #productModule {
    margin-top: 80rem;
  }

  /* #productModule .product-table {
      min-width: fit-content;
    } */
  #productModule .iBtn {
    display: none;
  }

  #productModule .product-box {
    overflow-x: auto;
    max-width: calc(100vw - 32rem);
    padding-bottom: 32rem;
  }

  /* 伪滚动条容器 */
  #productModule .fake-scrollbar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 90rem;
    height: 4px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    pointer-events: none;
    z-index: 9;
  }

  .innerTableContainer .fake-scrollbar {
    bottom: -55rem !important;
  }

  /* 伪滑块 */
  #productModule .fake-thumb {
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 2px;
    width: 0;
    /* js 动态算 */
    transition: width 0.2s;
  }

  #productModule .pageNavigation span {
    font-size: 40rem;
    margin-left: 8rem;
  }

  #productModule .pageNavigation span.notAllow {
    pointer-events: none;
    color: var(--ebc-text-tertiary);
  }

  #productModule .pageNavigation span:nth-child(1) {
    margin-right: 8rem;
  }

  #productModule .pageNavigation {
    gap: 8rem;
    padding-top: 48rem;
  }

  #productModule .pageNavigation div {
    padding: 4rem 18rem;
  }

  #productModule .pageNavigation .active {
    font-weight: 500;
    background: var(--ebc-neutral-bg_c);
    border-radius: 50%;
  }

  #productModule .product-table::-webkit-scrollbar,
  #productModule .product-box::-webkit-scrollbar {
    display: none;
  }

  #productModule .product-table-th .product-table-td {
    color: var(--ebc-text-secondary);
    padding: 16rem 0;
    justify-content: flex-end;
  }

  #productModule .product-table-th .product-table-td:nth-child(4),
  #productModule .product-table-th .product-table-td:nth-child(6) {
    justify-content: center;
  }

  #productModule .product-table-tr .product-table-td {
    // white-space: nowrap;
    line-height: 36rem;
    padding: 32rem 0;
  }

  #productModule .product-table-tr,
  #productModule .product-table-th {
    gap: 32rem;
    padding-right: 100rem;
    position: relative;
    width: fit-content;
  }

  #productModule.ar .product-table-tr .product-table-td:first-child,
  #productModule.ar .product-table-th .product-table-td:first-child {
    left: unset;
    right: 0;
  }

  #productModule.ar .product-table-tr,
  #productModule.ar .product-table-th {
    padding-left: 100rem;
    padding-right: 0;
  }

  #productModule .newTypeTable .product-table-tr .product-table-td:first-child,
  #productModule .newTypeTable .product-table-th .product-table-td:first-child {
    flex: 0 0 200rem;
    width: 200rem;
  }

  #productModule .product-table-tr .product-table-td:first-child,
  #productModule .product-table-th .product-table-td:first-child {
    flex-direction: column;
    flex: 0 0 350rem;
    width: 350rem;
    padding-left: 0;
    padding-right: 50rem;
    align-items: flex-start;
    justify-content: center;
    gap: 8rem;
    position: sticky;
    z-index: 99;
    left: 0;
    background: var(--ebc-basecolor-white-100);
  }

  .mn #productModule .product-table-tr .product-table-td:first-child,
  .mn #productModule .product-table-th .product-table-td:first-child {
    flex: 0 0 210rem;
    width: 210rem;
  }


  #productModule .product-table-tr .product-table-td:nth-child(5) {
    justify-content: flex-end;
  }

  .noScroll .product-table-tr .product-table-td:first-child::after,
  .noScroll .product-table-th .product-table-td:first-child::after {
    display: none !important;
  }

  #productModule .product-table-tr .product-table-td:first-child::after,
  #productModule .product-table-th .product-table-td:first-child::after {
    content: "";
    position: absolute;
    top: 0;
    right: -8px;
    /* 控制阴影条水平位置 */
    width: 8px;
    /* 阴影条宽度 */
    height: 100%;
    /* 贯穿整个行高 */
    background: linear-gradient(to right, rgba(0, 0, 0, 0.08), transparent);
    pointer-events: none;
    /* 不影响点击 */
  }

  #productModule.ar .product-table-tr .product-table-td:first-child::after,
  #productModule.ar .product-table-th .product-table-td:first-child::after {
    right: unset;
    left: -8px;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.08), transparent);
  }

  #productModule .product-table-tr .product-table-td:nth-child(2),
  #productModule .product-table-tr .product-table-td:nth-child(3),
  #productModule .product-table-th .product-table-td:nth-child(2),
  #productModule .product-table-th .product-table-td:nth-child(3) {
    flex: 0 0 112rem;
    width: 112rem;
  }

  #productModule.jp .product-table-tr .product-table-td:nth-child(4),
  #productModule.jp .product-table-th .product-table-td:nth-child(4),
  #productModule.kr .product-table-tr .product-table-td:nth-child(4),
  #productModule.kr .product-table-th .product-table-td:nth-child(4) {
    flex: 0 0 120rem;
    width: 120rem;
  }

  #productModule .product-table-tr .product-table-td:nth-child(4),
  #productModule .product-table-th .product-table-td:nth-child(4) {
    flex: 0 0 80rem;
    width: 80rem;
  }

  #productModule .product-table-tr .product-table-td:nth-child(6),
  #productModule .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 128rem;
    width: 128rem;
  }

  #productModule.es .product-table-tr .product-table-td:nth-child(5),
  #productModule.es .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 200rem;
    width: 200rem;
  }

  #productModule.es .product-table-tr .product-table-td:nth-child(6),
  #productModule.es .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 160rem;
    width: 160rem;
  }

  #productModule.jp .product-table-tr .product-table-td:nth-child(6),
  #productModule.jp .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 160rem;
    width: 160rem;
  }

  #productModule.mn .product-table-tr .product-table-td:nth-child(6),
  #productModule.mn .product-table-th .product-table-td:nth-child(6),
  #productModule.pt .product-table-tr .product-table-td:nth-child(6),
  #productModule.pt .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 240rem;
    width: 240rem;
  }

  #productModule.jp .product-table-tr .product-table-td:nth-child(5),
  #productModule.jp .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 150rem;
    width: 150rem;
  }

  #productModule.pt .product-table-tr .product-table-td:nth-child(5),
  #productModule.pt .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 200rem;
    width: 200rem;
  }

  #productModule .product-table-tr .product-table-td:nth-child(5),
  #productModule .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 96rem;
    width: 96rem;
    order: 2;
  }

  .formPopup {
    width: 100%;
    bottom: -110%;
    left: 0;
    transform: scale(0);
    top: unset;
    border-radius: 32rem 32rem 0 0;
    padding: 48rem 32rem 96rem;
  }

  .showFormPopup {
    bottom: 0;
    transform: scale(1);
  }

  .formPopup h2 {
    max-width: 75vw;
  }

  .formPopup h3 {
    margin: 16rem 0 48rem;
  }

  .formPopup svg {
    top: 55rem;
    right: 32rem;
    width: 48rem;
    height: 48rem;
  }

  .ar .formPopup svg {
    right: unset;
    left: 32rem;
  }

  .formPopup .product-table {
    max-width: calc(100vw - 64rem);
    overflow: auto;
    padding-bottom: 16rem;
  }

  .formPopup .product-table-row {
    position: relative;
  }

  /* .formPopup .product-table::-webkit-scrollbar{
      display: none;
    } */
  .formPopup .product-table .product-innertable-th,
  .formPopup .product-table .product-innertable-tr {
    padding-right: 24rem;
  }

  .formPopup .product-table .product-innertable-tr,
  .formPopup .product-table .product-innertable-th {
    gap: 48rem;
    /* width:fit-content; */
  }

  .formPopup .product-table .product-innertable-th {
    white-space: nowrap;
  }

  #productModule .product-innertable-th,
  #productModule .product-innertable-tr {
    height: 80rem;
  }

  #productModule .product-innertable-th {
    /* position: sticky; */
    background: var(--ebc-basecolor-white-100);
    /* top:0; */
    /* z-index: 10; */
  }

  #productModule .product-innertable-tbody {
    overflow: visible;
    height: 400rem;
  }

  .formPopup .product-innertable-th {
    width: fit-content;
  }

  .formPopup .product-innertable-td:first-child {
    position: sticky;
    left: 0;
    background: var(--ebc-basecolor-white-100);
    flex: 0 0 114rem !important;
    width: 114rem !important;
  }

  .ar .formPopup .product-innertable-td:first-child {
    left: unset;
    right: 0;
  }

  .formPopup .noScroll .product-innertable-td:first-child::after {
    display: none !important;
  }

  .formPopup .product-innertable-td:first-child::after {
    content: "";
    position: absolute;
    top: 0;
    right: -8px;
    /* 控制阴影条水平位置 */
    width: 8px;
    /* 阴影条宽度 */
    height: 100%;
    /* 贯穿整个行高 */
    background: linear-gradient(to right, rgba(0, 0, 0, 0.08), transparent);
    pointer-events: none;
    /* 不影响点击 */
  }

  .ar .formPopup .product-innertable-td:first-child::after {
    right: unset;
    left: -8px;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.08), transparent);
  }

  .formPopup .product-innertable-td:nth-child(2) {
    flex: 0 0 112rem !important;
    width: 112rem !important;
  }

  .formPopup .product-innertable-td:last-child {
    flex: 0 0 96rem !important;
    width: 96rem !important;
    justify-content: center !important;
  }

  .formPopup .product-innertable-td {
    flex: 0 0 160rem !important;
    width: 160rem;
  }

  /* 把上下三角重置 */
  .popover::before,
  .popover::after {
    left: -10px;
    /* 贴到 popover 左侧 */
    top: 50%;
    transform: translateY(-50%);
    border: 6px solid transparent;
  }

  /* 朝左的三角：右边框着色 */
  .popover::before {
    border-right-color: var(--ebc-neutral-bg_d);
  }

  .popover::after {
    left: -6px;
    border-right-color: var(--ebc-neutral-bg_d);
  }

  .ar.popover::before,
  .ar.popover::after {
    left: unset;
    right: -10px;
    border-left-color: var(--ebc-neutral-bg_d);
    border-right-color: transparent;
  }
}

.hiddenDC .product-table-th .product-table-td:nth-child(4),
.hiddenDC .product-table-tr .product-table-td:nth-child(4) {
  display: none !important;
}

/* ====== ETF 专属布局与组件样式 ====== */
#productModule .etf-layout .product-table-td {
  flex: 1.7 0 0 !important;
  justify-content: center;
}

.etf-layout>div:nth-child(4),
.etf-layout>div:nth-child(4) {
  display: none !important;
}

#productModule .etf-layout .product-table-th:nth-child(2),
#productModule .etf-layout .product-table-th:nth-child(3),
#productModule .etf-layout .product-table-th:nth-child(5),
#productModule .etf-layout .product-table-td:nth-child(2),
#productModule .etf-layout .product-table-td:nth-child(3),
#productModule .etf-layout .product-table-td:nth-child(5) {
  text-align: left !important;
  justify-content: flex-start !important;
}

#productModule .etf-layout .product-table-th:nth-child(6),
#productModule .etf-layout .product-table-td:nth-child(6) {
  justify-content: center !important;
}

#productModule .product-table-th.etf-layout {
  background: #fff;
  border-radius: 0;
}

#productModule .product-table-th.etf-layout .product-table-td {
  color: var(--ebc-text-secondary);
}

#productModule .product-box .product-table.etfLayoutTable {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 0;
}

/* 第一列特殊排版: 中英双语上下分行 */
#productModule .etf-layout .product-table-td:first-child {
  flex: 2.4 !important;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  line-height: 1.2;
  padding-inline: 32rem;
  gap: 4px;
}

#pageContainer .tableBtn {
  margin-top: 60rem;
  min-width: 180rem;
  display: flex;
  box-sizing: border-box;
}

@media (max-width: 996px) {
  #pageContainer .tableBtn {
    height: 80rem;
    font-size: 28rem;
    line-height: 0rem;
    margin: 80rem auto 0;
  }
}

/* #productModule .etf-layout .product-table-td:nth-child(2),
#productModule .etf-layout .product-table-td:nth-child(3),
#productModule .etf-layout .product-table-td:nth-child(2),
#productModule .etf-layout .product-table-td:nth-child(3){
  flex: 1!important;
} */
#productModule .etf-symbol-text {
  color: var(--ebc-text-secondary);
}

#productModule .product-table-tr.etf-layout .product-table-td {
  padding-block: 24rem;
}

/* 修复买卖价靠右排版 */

#productModule .etf-layout .product-table-td:nth-child(2),
#productModule .etf-layout .product-table-td:nth-child(3),
#productModule .etf-layout .product-table-td:nth-child(5) {
  text-align: left;
  justify-content: flex-start;
}



/* 2. 调整最后一列下拉菜单的位置：取消居中，改为右对齐，防止菜单超出右侧边界 */
#productModule .etf-layout .product-table-td:last-child .etf-dropdown-menu {
  left: auto;
  right: 0;
  transform: none;
}

/* 3. 同理，调整最后一列 Info 提示气泡的位置：改为右对齐 */
#productModule .etf-layout .product-table-td:last-child .tooltip-box {
  left: auto;
  right: 0;
  transform: none;
}

.dropdown-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  /* 稍微增加一点箭头的热区，防止太难移上去 */
  margin-left: 2px;
}

/* 下拉菜单外层：用于桥接鼠标悬浮的间隙，防止 mouseleave 断触 */
.etf-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding-top: 8px;
  /* 关键修复：用透明 padding 替代 margin，确保鼠标经过时不会脱离目标 */
  z-index: 100;
  min-width: 130rem;
}

/* 下拉菜单本体（带背景和阴影的部分） */
.etf-dropdown-menu-inner {
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: var(--ebc-corner-radius-rc08, 8px);
  padding: 8rem 0;
}

.etf-dropdown-item {
  padding: 8rem 20rem;
  text-align: left;
  cursor: pointer;
  font-size: 14rem;
  color: var(--ebc-text-secondary);
  white-space: nowrap;
  transition: background-color 0.2s;
  font-weight: 400;
  /* 重置掉表头的加粗 */
}


.etf-dropdown-item:hover,
.etf-dropdown-item.active {
  color: var(--ebc-text-primary);
  background: var(--ebc-neutral-bg_b, #f5f5f5);
}

/* ====== β列的 Info 提示框 ====== */
.info-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  font-size: 14rem;
  color: var(--ebc-text-tertiary, #999);
  margin-left: 2px;
  padding: 4px;
  /* 增加 Hover 热区 */
}

/* 提示气泡，也使用 padding 桥接法 */
.tooltip-box {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: var(--ebc-corner-radius-rc08, 8px);
  padding: 12rem 16rem;
  z-index: 101;
  width: 280rem;
  font-size: 14rem;
  color: var(--ebc-text-secondary, #666);
  margin-top: 8px;
  text-align: left;
  line-height: 1.6;
  font-weight: 400;
  /* 重置字体粗细 */
  white-space: normal;
  /* 允许文本自然换行 */
}

#productModule .etf-layout .product-table-td:nth-child(2),
#productModule .etf-layout .product-table-td:nth-child(3) {
  flex: 1 !important;
}

@media (min-width: 996px) {}

@media (max-width: 996px) {
  #productModule .etf-layout .product-table-td:nth-child(5) {
    order: unset;
  }

  #productModule .etf-layout.product-table-tr,
  #productModule .etf-layout.product-table-th {
    width: 250vw !important;
  }



  .tooltip-box,
  .etf-dropdown-item {
    font-size: 24rem;
    padding-block: 16rem;
  }

  .tooltip-box {
    width: 60vw;
  }

  .iconfont.icon-a-tipsicon {
    font-size: 24rem;
  }

  #productModule .product-table-th.etf-layout,
  #productModule .product-box .product-table.etfLayoutTable {
    border: 0;
  }
}
</style>
